import React__default, { forwardRef, createElement, useContext, useState, useEffect, useCallback, useRef, Fragment, Component, Children, isValidElement, PureComponent, useLayoutEffect, createRef, useMemo, memo } from 'react';
import { useEventListener, useInterval, QueryString, StringGuard, sortPrescriptionParameters, PrescriptionValueUtils } from '@grandvision/utils';
import classnames from 'classnames';
import { motion, AnimatePresence } from 'framer-motion';
import { Heading, Checkbox, ResponsiveImage, Hr } from '@grandvision/elements';
import { Icon } from '@grandvision/icons';
import SwipeableViews from 'react-swipeable-views';
import { useIntl, Currencies } from '@grandvision/state';
import useOnClickOutside from 'use-onclickoutside';
import currency from 'currency.js';
import { Marker, useLoadScript, GoogleMap, MarkerClusterer } from '@react-google-maps/api';
export { InfoWindow } from '@react-google-maps/api';
import get from 'lodash/get';
import { useInView } from 'react-intersection-observer';
import { CommerceToolsApi } from '@grandvision/commercetools';
import ReactDOM from 'react-dom';
import { Range, Handle } from 'rc-slider';
import ReactHtmlParser from 'react-html-parser';
import StickyNode from 'react-stickynode';
import { Manager, Reference, Popper } from 'react-popper';
import { toast, ToastContainer as ToastContainer$2, Slide } from 'react-toastify';
import { BreadcrumbList } from '@grandvision/analytics';

var getLabel = function (labelObject, labelKey, options) {
    if (options === void 0) { options = {
        hideLabelKey: false,
    }; }
    return parseLink((labelObject || {})[labelKey] ||
        options.defaultValue ||
        (options.hideLabelKey ? '' : "[" + labelKey + "]"));
};
// Creates a new set of labels from all labels that contain the `labelKey` string it their original key
function getLabelSet(labelKey, labels) {
    var labelSet = {};
    for (var key in labels) {
        if (labels.hasOwnProperty(key) && key.indexOf(labelKey) > -1) {
            labelSet[key] = labels[key];
        }
    }
    return labelSet;
}
// Parses MarkDown style links ()[] to HTML string
var parseLink = function (label) {
    var regex = /[\[]{1}([^\]\[]+)[\]]{1}[(]{1}([^()"]+)("(.+)")?[)]{1}/g;
    return label.replace(regex, '<a href="$2" title="$4">$1</a>');
};
// Splits labels that look like "bla bla <link>link bla</link>"
var extractLink = function (label) {
    var linkStart = label.lastIndexOf('<link>');
    var linkEnd = label.lastIndexOf('</link>');
    var linkText = label.substr(linkStart, linkEnd).replace('<link>', '').replace('</link>', '');
    var labelText = label.substr(0, linkStart);
    return {
        link: linkText || '',
        label: labelText || '',
    };
};

var getLabel$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getLabel: getLabel,
  getLabelSet: getLabelSet,
  parseLink: parseLink,
  extractLink: extractLink
});

var Link = forwardRef(function Link(_a, ref) {
    var url = _a.url, target = _a.target, className = _a.className, _b = _a.label, label = _b === void 0 ? '' : _b, children = _a.children, hidden = _a.hidden;
    var targetOpt = target === 'external' ? '_blank' : undefined;
    var rel = target === 'external' ? 'noreferrer noopener' : undefined;
    return (createElement("a", { ref: ref, className: className || undefined, href: url || '#', target: targetOpt, rel: rel, "aria-hidden": hidden }, children ? children : label));
});
Link.displayName = 'Link';

var Link$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': Link
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var BreakpointName;
(function (BreakpointName) {
    BreakpointName["PHONE"] = "PHONE";
    BreakpointName["TABLET_PORTRAIT"] = "TABLET_PORTRAIT";
    BreakpointName["TABLET_LANDSCAPE"] = "TABLET_LANDSCAPE";
    BreakpointName["DESKTOP"] = "DESKTOP";
})(BreakpointName || (BreakpointName = {}));
var MediaQueryContext = React__default.createContext({});
var useBreakpoint = function () {
    var currentBreakpoint = useContext(MediaQueryContext).currentBreakpoint;
    return currentBreakpoint;
};
var useIsBreakpoint = function (name) {
    var currentBreakpoint = useContext(MediaQueryContext).currentBreakpoint;
    return currentBreakpoint === name;
};
var useIsPhone = function () { return useIsBreakpoint(BreakpointName.PHONE); };
var useIsTabletPortrait = function () { return useIsBreakpoint(BreakpointName.TABLET_PORTRAIT); };
var useIsTabletLandscape = function () { return useIsBreakpoint(BreakpointName.TABLET_LANDSCAPE); };
var useIsDesktop = function () { return useIsBreakpoint(BreakpointName.DESKTOP); };
var breakpointRange = [
    BreakpointName.PHONE,
    BreakpointName.TABLET_PORTRAIT,
    BreakpointName.TABLET_LANDSCAPE,
    BreakpointName.DESKTOP,
];
// Check if the current breakpoint is above the argument
var useIsAbove = function (name) {
    var currentBreakpoint = useContext(MediaQueryContext).currentBreakpoint;
    return breakpointRange.indexOf(currentBreakpoint) > breakpointRange.indexOf(name);
};
// Check if the current breakpoint is below the argument
var useIsBelow = function (name) {
    var currentBreakpoint = useContext(MediaQueryContext).currentBreakpoint;
    return breakpointRange.indexOf(currentBreakpoint) < breakpointRange.indexOf(name);
};
function WithBreakpoints(Component) {
    var wrappedName = Component.displayName || Component.name || 'Component';
    var withBreakpoints = function (props) {
        var currentBreakpoint = useBreakpoint();
        return React__default.createElement(Component, __assign({}, props, { currentBreakpoint: currentBreakpoint }));
    };
    withBreakpoints.displayName = "WithBreakpoints(" + wrappedName + ")";
    return withBreakpoints;
}

var Breakpoints = {
    M: 768,
    L: 1024,
    XL: 1440,
};
/**
 * Checks current viewport width against our Breakpoints enumeration
 * and returns the one that is currently active
 */
var isMinWidth = function (width) { return window.matchMedia("(min-width: " + width + "px)").matches; };
var getCurrentBreakpoint = function () {
    if (isMinWidth(Breakpoints.XL)) {
        return BreakpointName.DESKTOP;
    }
    else if (isMinWidth(Breakpoints.L)) {
        return BreakpointName.TABLET_LANDSCAPE;
    }
    else if (isMinWidth(Breakpoints.M)) {
        return BreakpointName.TABLET_PORTRAIT;
    }
    else {
        return BreakpointName.PHONE;
    }
};

var MediaQueryProvider = function (_a) {
    var children = _a.children, _b = _a.initialBreakpoint, initialBreakpoint = _b === void 0 ? BreakpointName.PHONE : _b;
    var _c = __read(useState(initialBreakpoint), 2), currentBreakpoint = _c[0], setBreakpoint = _c[1];
    // Initial client mount update desktop to mobile if screensize is small.
    useEffect(function () {
        setBreakpoint(getCurrentBreakpoint());
    }, []);
    var handleResize = useCallback(function () {
        setBreakpoint(getCurrentBreakpoint());
    }, []);
    useEventListener('resize', handleResize);
    return (createElement(MediaQueryContext.Provider, { value: { currentBreakpoint: currentBreakpoint } }, children));
};



var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Context: MediaQueryContext,
  get BreakpointName () { return BreakpointName; },
  WithBreakpoints: WithBreakpoints,
  useBreakpoint: useBreakpoint,
  useIsAbove: useIsAbove,
  useIsBelow: useIsBelow,
  useIsDesktop: useIsDesktop,
  useIsPhone: useIsPhone,
  useIsTabletLandscape: useIsTabletLandscape,
  useIsTabletPortrait: useIsTabletPortrait,
  Provider: MediaQueryProvider,
  Breakpoints: Breakpoints,
  getCurrentBreakpoint: getCurrentBreakpoint
});



var sharedProps = /*#__PURE__*/Object.freeze({
  __proto__: null
});

function convertBrand(brand) {
    var query = /&/g;
    return brand.replace(query, '%26').toLowerCase();
}

/**
 * Converts a style string from the CMS to separate props to set on a Button component.
 * E.G. "secondary outline" => { theme: secondary, outline: true }
 *
 * This would be better suited to live in the bloomreach package,
 * but we can't add that dependency to common.
 */
function createButtonStyles(linkStyle) {
    var defaultButtonStyles = {
        color: 'primary',
        variant: 'solid',
    };
    var styles = linkStyle && linkStyle.split(' ');
    if (!styles || !styles.length) {
        return defaultButtonStyles;
    }
    return {
        color: styles.includes('secondary') ? 'secondary' : 'primary',
        variant: styles.includes('outline') ? 'outline' : 'solid',
    };
}

function setCustomEventPolyfill() {
    function CustomEvent(event, params) {
        if (params === void 0) { params = { bubbles: false, cancelable: false, detail: undefined }; }
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    CustomEvent.prototype = Event.prototype;
    window.CustomEvent = CustomEvent;
}
var createCustomEvent = function (eventName) {
    if (typeof window.CustomEvent !== 'function') {
        setCustomEventPolyfill();
    }
    return new window.CustomEvent(eventName);
};

var getKeyByValue = function (object, value) {
    return Object.keys(object).find(function (key) { return object[key] === value; }) || null;
};

var getQueryParamByKey = function (key) {
    var query = window.location.search.substring(1);
    var params = query.split('&');
    for (var i = 0; i < params.length; i++) {
        var pair = params[i].split('=');
        if (decodeURIComponent(pair[0]) === key) {
            return decodeURIComponent(pair[1]);
        }
    }
};

function throttle(fn, delay) {
    var canCall = true;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (canCall) {
            // eslint-disable-next-line prefer-spread
            fn.apply(null, args);
            canCall = false;
            setTimeout(function () {
                canCall = true;
            }, delay);
        }
    };
}

var pad = function (num) {
    var norm = Math.floor(Math.abs(num));
    return (norm < 10 ? '0' : '') + norm;
};
/**
 * Formats a date according to ISO format
 * and adds timezone at the end
 * @param {Date} date
 * @returns {string}
 */
var toISOString = function (date) {
    var tzo = -date.getTimezoneOffset();
    var dif = tzo >= 0 ? '+' : '-';
    return (date.getFullYear() +
        '-' +
        pad(date.getMonth() + 1) +
        '-' +
        pad(date.getDate()) +
        'T' +
        pad(date.getHours()) +
        ':' +
        pad(date.getMinutes()) +
        ':' +
        pad(date.getSeconds()) +
        '.' +
        pad(date.getMilliseconds()) +
        dif +
        pad(tzo / 60) +
        ':' +
        pad(tzo % 60));
};

var truncateString = function (text, desiredLength) {
    return text.length > desiredLength ? text.substring(0, desiredLength - 1) + '…' : text;
};

var easeInOutQuad = function (currentTime, start, change, duration) {
    currentTime /= duration / 2;
    if (currentTime < 1) {
        return (change / 2) * currentTime * currentTime + start;
    }
    currentTime--;
    return (-change / 2) * (currentTime * (currentTime - 2) - 1) + start;
};
var scrollToItem = function (elem, to, duration) {
    var start = elem.scrollTop;
    var change = to - start;
    var startDate = +new Date();
    var animateScroll = function () {
        var currentDate = +new Date();
        var currentTime = currentDate - startDate;
        elem.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
        if (window && currentTime < duration) {
            window.requestAnimationFrame(animateScroll);
        }
        else {
            elem.scrollTop = to;
        }
    };
    animateScroll();
};

var SCROLL_LOCKED_CLASS = 'scroll-locked';
var getLockElement = function () {
    return typeof document === 'undefined' ? null : document.body || null;
};
var isScrollLocked = function (lockElement) {
    var element = lockElement || getLockElement();
    return element ? element.classList.contains(SCROLL_LOCKED_CLASS) : false;
};
var getScrollY = function (scrollElement) {
    if (!scrollElement && typeof window === 'undefined') {
        return 0;
    }
    return scrollElement ? scrollElement.scrollTop : window.pageYOffset;
};
var setScrollY = function (position, scrollElement) {
    if (!scrollElement && typeof window === 'undefined') {
        return;
    }
    !scrollElement
        ? window.scrollTo(window.pageXOffset, position)
        : (scrollElement.scrollTop = position);
};
var lockScroll = function (position, scrollElement, lockElement) {
    var scrollY = position || getScrollY(scrollElement);
    var element = lockElement || getLockElement();
    if (!element) {
        return;
    }
    element.classList.add(SCROLL_LOCKED_CLASS);
    element.style.overflowY = 'hidden';
    element.style.position = 'fixed';
    element.style.top = "-" + scrollY + "px";
};
var unlockScroll = function (position, scrollElement, lockElement) {
    var element = lockElement || getLockElement();
    if (element === null) {
        return;
    }
    var top = position ? undefined : element.style.top;
    var scrollY = top ? Math.abs(parseInt(top, 10)) : position || 0;
    element.classList.remove(SCROLL_LOCKED_CLASS);
    element.style.overflowY = '';
    element.style.position = '';
    element.style.top = '';
    setScrollY(scrollY, scrollElement);
};

var windowOrGlobal = (typeof self === 'object' && self.self === self && self) ||
    (typeof global === 'object' && global.global === global && global) ||
    window;

// https://github.com/Modernizr/Modernizr/blob/master/feature-detects/touchevents.js
var mq = function (query) { return window.matchMedia(query).matches; };
// Only works on client side
var isTouchDevice = function () {
    if (typeof window === 'undefined') {
        return false;
    }
    var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    // @ts-ignore DocumentTouch is not recognized
    if ('ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch)) {
        return true;
    }
    var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
};

var LOCALE_DELIMITER = '_';
var LOCALE_REGEX = /[a-z]{2}(_|-)[A-Z]{2}/g;
/**
 * Takes an input locale and extracts the language part.
 * Locales are expected to be formatted according to ISO/IEC 15897, which is as as follows:
 * [language[_territory][.codeset][@modifier]].
 *
 * Supports both main language locales, like 'en' or 'fr' and locales with region or dialect, like 'en_AU' or 'fr_BE'.
 */
function getLanguageForLocale(locale) {
    if (locale.includes(LOCALE_DELIMITER)) {
        return locale.split(LOCALE_DELIMITER)[0].toLowerCase();
    }
    else {
        return locale.toLowerCase();
    }
}
/**
 * Converts a browser locale (it-IT) to ISO complaint locale (it_IT)
 */
function convertLocaleFormat(locale) {
    if (locale.length === 2) {
        return convertLocale(locale, locale);
    }
    if (locale.includes(LOCALE_DELIMITER)) {
        return locale;
    }
    if (locale.includes('-')) {
        return locale.replace('-', LOCALE_DELIMITER);
    }
    return locale;
}
/**
 * Checks if a locale is in valid format.
 * @param locale
 */
function isValidLocale(locale) {
    return !!locale.match(LOCALE_REGEX);
}
// Takes a language and optionally a country (like en or EN) and converts it to en_EN
function convertLocale(language, country) {
    if (country) {
        return "" + language.toLowerCase() + LOCALE_DELIMITER + country.toUpperCase();
    }
    else {
        return "" + language.toLowerCase() + LOCALE_DELIMITER + language.toUpperCase();
    }
}
/**
 * Takes a locale and returns the country part from it.
 * Accepts both formats, sv-SE and sv_SE both return SE.
 */
function convertLocaleToCountryCode(locale) {
    return locale.match(LOCALE_REGEX) ? locale.substring(3).toUpperCase() : locale.toUpperCase();
}
/**
 * Takes a locale and returns the language part from it.
 * Accepts both formats, sv-SE and sv_SE both return SV.
 */
function convertLocaleToLanguageCode(locale) {
    return locale.match(LOCALE_REGEX) ? locale.substring(0, 2).toLowerCase() : locale.toLowerCase();
}

var colorHexMap = {
    black: '#000000',
    white: '#ffffff',
    grey: '#f5f5f5',
};

var usePrevious = function (value) {
    var ref = useRef();
    useEffect(function () {
        ref.current = value;
    });
    return ref.current;
};



var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  convertBrand: convertBrand,
  createButtonStyles: createButtonStyles,
  createCustomEvent: createCustomEvent,
  getKeyByValue: getKeyByValue,
  getQueryParamByKey: getQueryParamByKey,
  throttle: throttle,
  toISOString: toISOString,
  truncateString: truncateString,
  scrollToItem: scrollToItem,
  windowOrGlobal: windowOrGlobal,
  isTouchDevice: isTouchDevice,
  colorHexMap: colorHexMap,
  usePrevious: usePrevious,
  SCROLL_LOCKED_CLASS: SCROLL_LOCKED_CLASS,
  lockScroll: lockScroll,
  isScrollLocked: isScrollLocked,
  unlockScroll: unlockScroll,
  getScrollY: getScrollY,
  setScrollY: setScrollY,
  getLanguageForLocale: getLanguageForLocale,
  convertLocaleFormat: convertLocaleFormat,
  isValidLocale: isValidLocale,
  convertLocale: convertLocale,
  convertLocaleToCountryCode: convertLocaleToCountryCode,
  convertLocaleToLanguageCode: convertLocaleToLanguageCode
});

var Accordion = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (createElement("article", { className: classnames('accordion', className), "data-t": rest['data-t'] || 'accordion' }, children));
};

var animations = {
    expanded: {
        height: 'auto',
        opacity: 1,
        transition: {
            ease: 'easeOut',
            duration: 0.15,
        },
    },
    collapsed: {
        height: '0px',
        opacity: 0,
        transition: {
            ease: 'easeIn',
            duration: 0.15,
        },
    },
};
var AccordionItem = function (_a) {
    var id = _a.id, label = _a.label, children = _a.children, onClick = _a.onClick, _b = _a.headingLevel, headingLevel = _b === void 0 ? 'h2' : _b, _c = _a.expanded, expanded = _c === void 0 ? false : _c;
    var isMobile = useIsBelow(BreakpointName.TABLET_LANDSCAPE);
    var _d = __read(useState(expanded), 2), isExpanded = _d[0], setIsExpanded = _d[1];
    var _e = __read(useState(false), 2), hasFocus = _e[0], setHasFocus = _e[1];
    var handleClick = useCallback(function () {
        setIsExpanded(function (expanded) {
            onClick && onClick(!expanded);
            return !expanded;
        });
    }, []);
    var handleFocus = useCallback(function () { return setHasFocus(true); }, []);
    var handleBlur = useCallback(function () { return setHasFocus(false); }, []);
    // Allow prop updates to override the local state
    useEffect(function () {
        if (expanded !== isExpanded) {
            setIsExpanded(expanded);
        }
    }, [expanded]);
    return (createElement("section", { "data-t": "accordion-item", className: classnames('accordion-item', { 'accordion-item--focus': hasFocus }) },
        createElement("button", { id: id + "-control", className: "accordion-item__head", "aria-label": label, "aria-controls": id, "aria-expanded": isExpanded, onClick: handleClick, onFocus: handleFocus, onBlur: handleBlur },
            createElement(Heading, { component: headingLevel, className: "accordion-item__label", variant: isMobile ? 'subheading1' : 'smallest' }, label),
            createElement(Icon, { name: isExpanded ? 'minus' : 'plus', className: "accordion-item__icon", height: 32, width: 32 })),
        createElement(motion.div, { id: id, className: "accordion-item__body", "aria-labelledby": id + "-control", "aria-hidden": !isExpanded, initial: animations.collapsed, animate: isExpanded ? animations.expanded : animations.collapsed }, children)));
};

var renderContent = function (message) {
    if (typeof message === 'string') {
        return createElement("p", { className: "alert__message" }, message);
    }
    else {
        return (message &&
            message.map(function (m) { return (createElement("p", { key: m, className: "alert__message" }, m)); }));
    }
};
var Alert = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'info' : _b, message = _a.message, icon = _a.icon, title = _a.title, children = _a.children, className = _a.className;
    if (!children && !message && !title) {
        return null;
    }
    var classes = classnames("alert", "alert--" + type, className, {
        'alert--with-icon': icon,
    });
    return (createElement("div", { className: classes, "data-t": "alert-" + type },
        icon && createElement(Icon, { name: icon, className: "alert__icon" }),
        title && createElement("h5", { className: "alert__title" }, title),
        message && renderContent(message),
        children && createElement("div", { className: "alert__children" }, children)));
};

var defaultPoseConfig = {
    exit: {
        opacity: 0,
    },
    enter: {
        opacity: 1,
    },
};
/**
 * Consuming components that handle <AnimatePresence> themselves should be able
 * to not have Backdrop wrapped in an <AnimatePresence> component.
 */
var Wrapper = function (_a) {
    var animate = _a.animate, children = _a.children;
    return animate ? (createElement(AnimatePresence, null, children)) : (createElement(Fragment, null, children));
};
var Backdrop = function (_a) {
    var className = _a.className, isVisible = _a.isVisible, onClick = _a.onClick, _b = _a.poseConfig, poseConfig = _b === void 0 ? defaultPoseConfig : _b, _c = _a.animate, animate = _c === void 0 ? false : _c;
    return (createElement(Wrapper, { animate: animate }, isVisible && (createElement(motion.div, { key: "backdrop", className: classnames('backdrop', className), role: "presentation", onClick: onClick, variants: poseConfig, initial: "exit", animate: "enter", exit: "exit" }))));
};

var Loader = function (_a) {
    var className = _a.className;
    return (createElement("div", { "aria-hidden": "true", className: classnames('loader', className) }));
};

var renderButtonContent = function (icon, caption) {
    if (icon === void 0) { icon = ''; }
    return (createElement(Fragment, null,
        icon && (createElement("span", { className: "button__icon" },
            createElement(Icon, { name: icon }))),
        createElement("span", { className: "button__text" }, caption),
        createElement("div", { className: "button__loader-wrapper" },
            createElement(Loader, { className: "button__loader" }))));
};
var Button = function (_a) {
    var caption = _a.caption, _b = _a.type, type = _b === void 0 ? 'button' : _b, _c = _a.variant, variant = _c === void 0 ? 'solid' : _c, _d = _a.size, size = _d === void 0 ? 'medium' : _d, _e = _a.color, color = _e === void 0 ? 'primary' : _e, buttonId = _a.buttonId, disabled = _a.disabled, isLoading = _a.isLoading, icon = _a.icon, btnRef = _a.btnRef, href = _a.href, hrefTarget = _a.hrefTarget, className = _a.className, form = _a.form, onClick = _a.onClick, rest = __rest(_a, ["caption", "type", "variant", "size", "color", "buttonId", "disabled", "isLoading", "icon", "btnRef", "href", "hrefTarget", "className", "form", "onClick"]);
    var classes = classnames("button button--" + variant + " button--" + size + " button--color-" + color, className, {
        _is_disabled: disabled,
        _is_loading: isLoading,
    });
    if (href) {
        return disabled ? (createElement("div", { className: classes, "data-t": rest['data-t'] }, renderButtonContent(icon, caption))) : (createElement("a", { className: classes, href: href, target: hrefTarget, rel: hrefTarget === '_blank' ? 'noreferrer noopener' : undefined, "aria-busy": isLoading, "data-t": rest['data-t'], "aria-label": rest['aria-label'], onClick: onClick }, renderButtonContent(icon, caption)));
    }
    return (createElement("button", { type: type, id: buttonId, className: classes, onClick: (!disabled && onClick) || undefined, disabled: isLoading || disabled || false, "aria-label": rest['aria-label'], "aria-busy": isLoading, "data-t": rest['data-t'], form: form, ref: btnRef }, renderButtonContent(icon, caption)));
};

var Card = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (createElement("div", { "data-t": rest['data-t'], className: classnames('card', className) }, children));
};

var INTERVAL = 4000;
var Carousel = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.autoLoop, autoLoop = _b === void 0 ? false : _b, _c = _a.navigation, navigation = _c === void 0 ? true : _c, _d = _a.pagination, pagination = _d === void 0 ? true : _d, _e = _a.inverseColor, inverseColor = _e === void 0 ? false : _e, dataT = _a["data-t"];
    var getLabel = useIntl().getLabel;
    var _f = __read(useState(0), 2), activeIndex = _f[0], setActiveIndex = _f[1];
    var setSlide = useCallback(function (index) {
        if (index !== activeIndex) {
            setActiveIndex(index);
        }
    }, [activeIndex]);
    var prevSlide = useCallback(function () {
        setActiveIndex(function (index) { return (index !== 0 ? index - 1 : children.length); });
    }, []);
    var nextSlide = useCallback(function () {
        setActiveIndex(function (index) { return (index !== children.length - 1 ? index + 1 : 0); });
    }, []);
    var handlePrevClick = useCallback(function (e) {
        prevSlide();
        e.preventDefault();
    }, []);
    var handleNextClick = useCallback(function (e) {
        nextSlide();
        e.preventDefault();
    }, []);
    useInterval(nextSlide, autoLoop ? INTERVAL : null);
    if (!children || children.length === 0) {
        return null;
    }
    return (createElement("div", { className: classnames('carousel', className), "data-t": dataT || 'carousel' },
        createElement("div", { className: "carousel__inner" },
            createElement(SwipeableViews, { style: { height: '100%' }, onChangeIndex: setSlide, enableMouseEvents: true, index: activeIndex }, children.map(function (child, i) { return (createElement("div", { className: "carousel__item", key: "item-" + i }, child)); }))),
        navigation && (createElement(Fragment, null,
            createElement("button", { className: classnames('carousel__navigation-chevron carousel__navigation-chevron--left', {
                    disabled: activeIndex < 1,
                    inversed: inverseColor,
                }), disabled: activeIndex < 1, onClick: handlePrevClick, "aria-label": getLabel('common.actions.previous') },
                createElement(Icon, { name: "chevron-left" })),
            createElement("button", { className: classnames('carousel__navigation-chevron carousel__navigation-chevron--right', {
                    disabled: activeIndex >= children.length - 1,
                    inversed: inverseColor,
                }), disabled: activeIndex >= children.length - 1, onClick: handleNextClick, "aria-label": getLabel('common.actions.next') },
                createElement(Icon, { name: "chevron-right" })))),
        pagination && (createElement("div", { className: "carousel__pagination" }, children.map(function (child, index) { return (createElement("span", { key: index, role: "button", className: classnames('carousel__pagination-indicator', {
                _is_active: index === activeIndex,
            }), onClick: function () { return setSlide(index); } })); })))));
};

var CartCounter = function (_a) {
    var count = _a.count;
    return (createElement(Fragment, null,
        createElement(Icon, { name: "shopping-bag" }),
        count > 0 && createElement("span", { className: "cart-counter" }, count)));
};

var CartButton = /** @class */ (function (_super) {
    __extends(CartButton, _super);
    function CartButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            count: 0,
        };
        _this.onStoredCartChange = function () {
            var count = CartButton.getCartCount();
            _this.setState({ count: count });
        };
        return _this;
    }
    CartButton.getCartCount = function () {
        var fromStorage = window.localStorage.getItem('stored_cart');
        if (!fromStorage) {
            return 0;
        }
        var cart = JSON.parse(fromStorage);
        return cart && cart.cartId ? cart.cartCount : 0;
    };
    CartButton.prototype.componentDidMount = function () {
        // Get and set count on load
        var count = CartButton.getCartCount();
        this.setState({ count: count });
        // update cart count in current window and other windows
        window.addEventListener('cart.change', this.onStoredCartChange);
        window.addEventListener('storage', this.onStoredCartChange);
    };
    CartButton.prototype.componentWillUnmount = function () {
        window.removeEventListener('storage', this.onStoredCartChange);
        window.removeEventListener('cart.change', this.onStoredCartChange);
    };
    CartButton.prototype.render = function () {
        var count = this.state.count;
        var _a = this.props, href = _a.href, className = _a.className, label = _a.label;
        return (createElement("a", { className: "cart-button " + (className || ''), href: href, title: label },
            createElement(CartCounter, { count: count })));
    };
    CartButton.defaultProps = {
        href: '/cart',
    };
    return CartButton;
}(Component));

var CheckboxList = function (_a) {
    var idPrefix = _a.idPrefix, items = _a.items, selectedItems = _a.selectedItems, getItemIdentifier = _a.getItemIdentifier, renderItem = _a.renderItem, renderTrailingItem = _a.renderTrailingItem, onChange = _a.onChange, isItemDisabled = _a.isItemDisabled, _b = _a.checkboxAlignment, checkboxAlignment = _b === void 0 ? 'top' : _b, className = _a.className, itemClassName = _a.itemClassName;
    var handleChange = useCallback(function (_a) {
        var value = _a.value, checked = _a.checked;
        if (!onChange) {
            return;
        }
        var newValues = checked
            ? __spread(selectedItems, [value]) : selectedItems.filter(function (i) { return getItemIdentifier(i) !== getItemIdentifier(value); });
        onChange(newValues);
    }, [selectedItems, getItemIdentifier, onChange]);
    return (createElement("fieldset", { className: classnames('checkbox-list', className) }, items.map(function (item) {
        var id = idPrefix + String(getItemIdentifier(item));
        var isSelected = selectedItems.some(function (i) { return getItemIdentifier(i) === getItemIdentifier(item); });
        var isDisabled = isItemDisabled === null || isItemDisabled === void 0 ? void 0 : isItemDisabled(item);
        var trailingMarkup = renderTrailingItem === null || renderTrailingItem === void 0 ? void 0 : renderTrailingItem(item);
        return (createElement("div", { key: id, className: classnames('checkbox-list__item', itemClassName) },
            createElement("div", { className: "checkbox-list__item-checkbox checkbox-list__item-checkbox--" + checkboxAlignment },
                createElement(Checkbox, { id: id, value: item, checked: isSelected, disabled: isDisabled, onChange: handleChange })),
            createElement("div", { className: "checkbox-list__item-content" },
                createElement("label", { className: "checkbox-list__item-label", htmlFor: id }, renderItem(item)),
                trailingMarkup && (createElement("span", { className: "checkbox-list__item-trailing" }, trailingMarkup)))));
    })));
};

var TabLink = forwardRef(function (_a, ref) {
    var isActive = _a.isActive, className = _a.className, rest = __rest(_a, ["isActive", "className"]);
    return (createElement(Link, __assign({}, rest, { ref: ref, className: classnames('tab', className, { _is_active: isActive }) })));
});
TabLink.displayName = 'TabLink';

var setElementScrollLeft = function (element, value) {
    element.scrollLeft = value;
};
var Tabs = function (_a) {
    var children = _a.children, onChange = _a.onChange, activeTabIndex = _a.activeTabIndex, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b;
    var tabsRef = useRef(null);
    var activeTabRef = useRef(null);
    var _c = __read(useState(false), 2), isScrolling = _c[0], setIsScrolling = _c[1];
    useEffect(function () {
        var setScrolling = function (current) {
            var offsetWidth = current.offsetWidth, scrollWidth = current.scrollWidth;
            offsetWidth < scrollWidth ? setIsScrolling(true) : setIsScrolling(false);
        };
        var onResize = function () {
            setScrolling(tabsRef.current);
        };
        if (tabsRef.current) {
            setScrolling(tabsRef.current);
            window.addEventListener('resize', onResize);
            activeTabRef.current && setElementScrollLeft(tabsRef.current, activeTabRef.current.offsetLeft);
        }
        return function () { return window.removeEventListener('resize', onResize); };
    }, [tabsRef.current]);
    return (React__default.createElement("div", { className: "tabs__wrapper" },
        React__default.createElement("div", { className: classnames("tabs tabs--" + variant, { 'tabs--scrolling': isScrolling }), ref: tabsRef },
            React__default.Children.map(children, function (child, index) {
                if (React__default.isValidElement(child)) {
                    return React__default.cloneElement(child, {
                        onClick: function () { return onChange && onChange(index); },
                        isActive: activeTabIndex === index,
                        variant: variant,
                        ref: activeTabIndex === index ? activeTabRef : undefined,
                    });
                }
            }),
            isScrolling && React__default.createElement(Icon, { className: "tabs__scroll-icon", name: "chevron-right" }))));
};

var ContentTabs = function (_a) {
    var links = _a.links;
    var _b = __read(useState(-1), 2), activeTabIndex = _b[0], setActiveTabIndex = _b[1];
    useEffect(function () {
        if (typeof window !== 'undefined' && links && links.length) {
            var path_1 = window.location.pathname;
            var tabIndex = links.findIndex(function (_a) {
                var url = _a.url;
                return url === path_1;
            });
            setActiveTabIndex(tabIndex);
        }
    }, [links]);
    return links && links.length ? (React__default.createElement(Tabs, { activeTabIndex: activeTabIndex }, links.map(function (_a) {
        var label = _a.label, url = _a.url, openInNewWindow = _a.openInNewWindow;
        return label &&
            url && React__default.createElement(TabLink, { key: url, url: url, label: label, openInNewWindow: openInNewWindow });
    }))) : null;
};

/**
 * This component can be use to catch any errors rendered from the subtree. Use as following:
 * <ErrorBoundary>
 *   {(error, info) =>
 *     error ? (
 *       <h1>There was an error</h1>
 *      ) : (
 *        <YourPossiblyFailingComponent />
 *      )
 *    }
 * </ErrorBoundary>
 */
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            error: undefined,
            errorInfo: undefined,
        };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        return { error: error };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({ error: error, errorInfo: errorInfo });
    };
    ErrorBoundary.prototype.render = function () {
        var _a = this.state, error = _a.error, errorInfo = _a.errorInfo;
        return this.props.children(error, errorInfo);
    };
    return ErrorBoundary;
}(React__default.Component));

var IconLink = function (_a) {
    var className = _a.className, href = _a.href, iconName = _a.iconName, onClick = _a.onClick, children = _a.children;
    return (createElement("div", { className: classnames('icon-link', className), onClick: onClick, role: "navigation" },
        createElement(Icon, { name: iconName }),
        createElement("a", { href: href }, children)));
};

var Column = function (_) { return null; };
Column.displayName = 'Column';
var defaultRowKeyFormatter = function (rowIndex) { return rowIndex.toString(); };
var Table = function (_a) {
    var caption = _a.caption, children = _a.children, numberOfRows = _a.numberOfRows, ariaLevel = _a["aria-level"], _b = _a.rowKeyFormatter, rowKeyFormatter = _b === void 0 ? defaultRowKeyFormatter : _b;
    if (!children) {
        console.warn("<DataTable /> component needs a column definition to work");
        return null;
    }
    var currentBreakpoint = useBreakpoint();
    var isMobile = currentBreakpoint === BreakpointName.TABLET_PORTRAIT ||
        currentBreakpoint === BreakpointName.PHONE;
    var columns = Children.toArray(children).reduce(function (result, child) {
        if (!isValidElement(child) || child.type !== Column) {
            // Ignoring all non <Column /> children
            return result;
        }
        return __spread(result, [
            {
                renderer: child.props.children,
                header: child.props.header,
                key: child.props.id || child.props.header,
            },
        ]);
    }, []);
    return (createElement("div", { className: "data-table" },
        createElement("h4", { "aria-level": ariaLevel }, caption),
        createElement("div", { className: "data-table__wrapper" }, isMobile ? (createElement("ul", { "aria-label": caption }, Array.from({ length: numberOfRows }).map(function (_, index) { return (createElement("li", { key: rowKeyFormatter(index) },
            createElement("dl", null, columns.map(function (c) { return (createElement(Fragment, { key: c.key },
                createElement("dt", null, c.header),
                createElement("dd", null, c.renderer(index)))); })))); }))) : (createElement("table", { "aria-label": caption },
            createElement("thead", null,
                createElement("tr", null, columns.map(function (c) { return (createElement("th", { scope: "col", key: c.key }, c.header)); }))),
            createElement("tbody", null, Array.from({ length: numberOfRows }).map(function (_, index) { return (createElement("tr", { key: rowKeyFormatter(index) }, columns.map(function (c) { return (createElement("td", { key: c.key }, c.renderer(index))); }))); })))))));
};
Table.Col = Column;

var options = { year: 'numeric', month: 'long', day: 'numeric' };
var DateTime = function (_a) {
    var dateTime = _a.dateTime, rest = __rest(_a, ["dateTime"]);
    var date = dateTime instanceof Date ? dateTime : new Date(dateTime);
    var locale = rest.locale;
    if (locale) {
        // Browsers require BCP 47 language tag format (see: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument)
        locale = locale.replace('_', '-');
    }
    return createElement("time", { dateTime: date.toISOString() }, date.toLocaleDateString(locale, options));
};

/**
 * Product detail discount bar
 */
var DiscountBar = function (_a) {
    var title = _a.title;
    return (createElement("div", { className: "discount-bar" },
        createElement("span", { className: "discount-bar__title" }, title)));
};

var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: _this.props.value || '',
            isValid: !!_this.props.value || _this.props.options.length === 1,
        };
        _this.handleChange = function (event) {
            var value = event.currentTarget.value;
            _this.setState({
                value: value || '',
                isValid: _this.isValid(value),
            }, function () { return _this.props.handleChange && _this.props.handleChange(_this.state); });
        };
        _this.isValid = function (value) {
            return value !== '';
        };
        return _this;
    }
    Dropdown.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this.props, disabled = _a.disabled, options = _a.options, value = _a.value;
        if (value !== undefined && value !== prevProps.value && value !== prevState.value) {
            this.setState({
                value: value,
                isValid: value !== '',
            });
        }
        // Reset to initialState when disabled forcing a "reset"
        if (disabled && disabled !== prevProps.disabled) {
            this.setState({
                value: value || '',
                isValid: !!value || options.length === 1,
            });
        }
    };
    Dropdown.prototype.render = function () {
        var _this = this;
        var _a = this.props, name = _a.name, options = _a.options, disabled = _a.disabled, _b = _a.className, className = _b === void 0 ? '' : _b, style = _a.style, placeholder = _a.placeholder, placeholderHidden = _a.placeholderHidden, _c = _a.required, required = _c === void 0 ? true : _c;
        var singleOption = options && options.length < 2;
        var isDisabled = disabled ? 'dropdown--disabled' : '';
        var isSingle = singleOption ? 'dropdown--disabled-single' : '';
        if (!options || (options.length === 1 && options[0] === null)) {
            return null;
        }
        return (createElement("div", { className: "dropdown " + isDisabled + " " + isSingle + " " + className, style: style },
            createElement("label", { className: "dropdown__label", htmlFor: name }, name),
            createElement("select", { required: required, className: "dropdown__select" + (this.state.isValid ? ' _is_valid' : ' _is_invalid'), name: name, id: name, value: this.state.value, disabled: disabled || singleOption || false, onChange: this.handleChange, "data-t": this.props['data-t'] },
                options.length > 1 && placeholder && (createElement("option", { className: "dropdown__placeholder", value: "", "aria-selected": this.state.value === '', hidden: placeholderHidden || false }, placeholder)),
                options.map(function (_a) {
                    var value = _a.value, label = _a.label;
                    if (value === null) {
                        return;
                    }
                    return (createElement("option", { key: value, value: value, className: "dropdown__option", "data-t": value, "aria-selected": _this.state.value === value }, label));
                })),
            options.length > 1 && createElement(Icon, { name: "chevron-down" })));
    };
    return Dropdown;
}(Component));

var Expandable = /** @class */ (function (_super) {
    __extends(Expandable, _super);
    function Expandable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isExpanded: false,
        };
        _this.toggleExpand = function (event) {
            event.preventDefault();
            _this.setState({
                isExpanded: !_this.state.isExpanded,
            });
        };
        return _this;
    }
    Expandable.prototype.render = function () {
        var _a = this.props, showMoreLabel = _a.showMoreLabel, showLessLabel = _a.showLessLabel, initialHeight = _a.initialHeight, children = _a.children;
        var toggleText = this.state.isExpanded ? showLessLabel : showMoreLabel;
        var expandedClass = this.state.isExpanded ? '_is_expanded' : '';
        if (!children) {
            return null;
        }
        return (createElement("div", { className: "expandable " + expandedClass },
            createElement("div", { className: "expandable__body", style: { maxHeight: initialHeight + 'px' } }, this.props.children),
            createElement("a", { className: "expandable__toggle", href: "#", onClick: this.toggleExpand }, toggleText)));
    };
    Expandable.defaultProps = {
        initialHeight: 0,
    };
    return Expandable;
}(Component));

var EyeSideIndicator = function (_a) {
    var className = _a.className, side = _a.side;
    var getLabel = useIntl().getLabel;
    return (createElement("div", { className: classnames("eyeside-indicator", "eyeside-indicator--" + side, className) }, getLabel("common." + side + ".abbr")));
};

var FeatureGroupItem = function (_a) {
    var id = _a.id, icon = _a.icon, link = _a.link;
    return (createElement("li", { className: "feature-group-item" },
        createElement("a", { href: link.url, className: "feature-group-item__box" },
            createElement("div", { className: "feature-group-item__imagebox" },
                createElement(Icon, { className: "feature-group-item__icon", name: icon })),
            link.label && createElement("span", { className: "feature-group-item__title" }, link.label))));
};
var FeatureGroup = function (_a) {
    var items = _a.items;
    if (!items) {
        return null;
    }
    return (createElement("div", { className: "feature-group" },
        createElement("div", { className: "site-container" },
            createElement("ul", { className: "feature-group__list" }, items && items.map(function (item) { return createElement(FeatureGroupItem, __assign({ key: item.id }, item)); })))));
};

var transition = { ease: 'easeOut', duration: 0.15 };
var variants = {
    enter: { y: 0, opacity: 1, transition: transition },
    exit: { y: -5, opacity: 0, transition: transition },
};
var FlyoutMenu = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React__default.createElement(motion.ul, __assign({}, rest, { role: "menu", className: classnames("flyout-menu", className), variants: variants, initial: "exit", animate: "enter", exit: "exit" })));
};

var FlyoutMenuItem = function (_a) {
    var link = _a.link, action = _a.action, children = _a.children, className = _a.className, rest = __rest(_a, ["link", "action", "children", "className"]);
    return (React__default.createElement("li", __assign({ className: classnames('flyout-menu-item', className) }, rest),
        !action && link && (React__default.createElement("a", { href: link, className: "flyout-menu-item__link" }, children)),
        action && (React__default.createElement("button", { onClick: action, className: "flyout-menu-item__link" }, children))));
};

var FlyoutTrigger = function (_a) {
    var children = _a.children, className = _a.className, isMenuOpen = _a.isMenuOpen, rest = __rest(_a, ["children", "className", "isMenuOpen"]);
    var classNames = classnames('flyout-trigger', className, {
        'flyout-trigger--menu-open': isMenuOpen,
    });
    return (React__default.createElement("button", __assign({}, rest, { "aria-expanded": isMenuOpen, "aria-haspopup": true, className: classNames }),
        children,
        React__default.createElement(Icon, { name: "chevron-down", className: "flyout-trigger__icon" })));
};

/**
 * This function takes inspiration from here:
 * https://github.com/Andarist/use-onclickoutside/blob/master/src/index.ts
 */
function useOnKeyboardEventOutside(ref, handler) {
    React__default.useEffect(function () {
        if (!handler || !document) {
            return;
        }
        var listener = function (event) {
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener('keyup', listener);
        return function () {
            document.removeEventListener('keyup', listener);
        };
    }, [!handler]);
}

var Flyout = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    var _b = __read(useState(false), 2), isOpen = _b[0], setIsOpen = _b[1];
    var rootRef = useRef(null);
    useOnClickOutside(rootRef, function () {
        setIsOpen(false);
    });
    useOnKeyboardEventOutside(rootRef, function (event) {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
            setIsOpen(false);
        }
    });
    function onKeyPress(event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
            setIsOpen(false);
        }
    }
    useEffect(function () {
        window.addEventListener('keyup', onKeyPress);
        return function () {
            window.removeEventListener('keyup', onKeyPress);
        };
    }, [onKeyPress]);
    var handleOnClick = useCallback(function () {
        setIsOpen(!isOpen);
    }, [isOpen, setIsOpen]);
    return (createElement("div", __assign({ className: classnames('flyout', className), ref: rootRef }, rest),
        createElement(AnimatePresence, null, Children.map(children, function (child) {
            if (!isValidElement(child)) {
                return;
            }
            if (child.type === FlyoutTrigger) {
                return (createElement(FlyoutTrigger, __assign({ key: "trigger" }, child.props, { onClick: handleOnClick, isMenuOpen: isOpen })));
            }
            if (child.type === FlyoutMenu) {
                return isOpen && createElement(FlyoutMenu, __assign({ key: "menu" }, child.props));
            }
            if (process.env.NODE_ENV !== 'production') {
                console.error('Flyout only accepts Flyout.Trigger and Flyout.Menu as its children');
            }
        }))));
};
Flyout.Trigger = FlyoutTrigger;
Flyout.Menu = FlyoutMenu;
Flyout.MenuItem = FlyoutMenuItem;

var PreloadFonts = function (_a) {
    var assetsUrl = _a.assetsUrl, fonts = _a.fonts;
    return (createElement(Fragment, null, fonts.map(function (font) { return (createElement("link", { key: font, rel: "preload", as: "font", href: assetsUrl + "/" + font + ".woff2", type: "font/woff2", crossOrigin: "anonymous" })); })));
};

var EUR = function (value, precision) {
    return currency(value, {
        pattern: "! #",
        separator: '.',
        decimal: ',',
        symbol: '€',
        precision: precision,
        formatWithSymbol: true,
    }).format();
};
var GBP = function (value, precision) {
    return currency(value, {
        pattern: "! #",
        separator: ',',
        decimal: '.',
        symbol: '£',
        precision: precision,
        formatWithSymbol: true,
    }).format();
};
var USD = function (value, precision) {
    return currency(value, {
        pattern: "! #",
        separator: ',',
        decimal: '.',
        symbol: '$',
        precision: precision,
        formatWithSymbol: true,
    }).format();
};
var SEK = function (value, precision) {
    return currency(value, {
        pattern: "# !",
        separator: ' ',
        decimal: ',',
        symbol: 'kr',
        precision: precision,
        formatWithSymbol: true,
    }).format();
};
var DKK = function (value, precision) {
    return currency(value, {
        pattern: "# !",
        separator: '.',
        decimal: ',',
        symbol: 'kr.',
        precision: precision,
        formatWithSymbol: true,
    }).format();
};

var _a;
var currencies = (_a = {},
    _a[Currencies.DKK] = {
        formatter: DKK,
    },
    _a[Currencies.EUR] = {
        formatter: EUR,
    },
    _a[Currencies.GBP] = {
        formatter: GBP,
    },
    _a[Currencies.USD] = {
        formatter: USD,
    },
    _a[Currencies.SEK] = {
        formatter: SEK,
    },
    _a);
var getPrice = function (value, currency, centAmount) {
    var precision = !centAmount || value % 100 === 0 ? 0 : 2;
    var price = centAmount ? value / 100 : value;
    var formattingRules = currencies[currency] || currencies.EUR;
    return isNaN(price) ? "--" : formattingRules.formatter(price, precision);
};
var Price = function (_a) {
    var value = _a.value, _b = _a.centAmount, centAmount = _b === void 0 ? true : _b, _c = _a.currency, currency = _c === void 0 ? 'EUR' : _c, className = _a.className, _d = _a.type, type = _d === void 0 ? 'default' : _d, _e = _a.size, size = _e === void 0 ? 'custom' : _e, rest = __rest(_a, ["value", "centAmount", "currency", "className", "type", "size"]);
    return (createElement("span", __assign({}, rest, { className: classnames('price', "price--" + type, "price--" + size, className) }), getPrice(value, currency, centAmount)));
};

var PriceTag = function (_a) {
    var originalPrice = _a.originalPrice, _b = _a.originalCentAmount, originalCentAmount = _b === void 0 ? true : _b, discountedPrice = _a.discountedPrice, _c = _a.discountedCentAmount, discountedCentAmount = _c === void 0 ? true : _c, _d = _a.currency, currency = _d === void 0 ? 'EUR' : _d, className = _a.className;
    var getLabel = useIntl().getLabel;
    return (createElement("span", { className: classnames('price-tag', className) },
        createElement(Price, { "aria-label": getLabel('common.originalPrice'), value: originalPrice, centAmount: originalCentAmount, currency: currency, type: typeof discountedPrice !== 'undefined' ? 'strikethrough' : 'default', className: "price-tag__price" }),
        typeof discountedPrice !== 'undefined' && (createElement(Price, { "aria-label": getLabel('common.discountedPrice'), value: discountedPrice, centAmount: discountedCentAmount, currency: currency, className: "price-tag__price" }))));
};

var classPrefix = 'prescription-glasses-bundle-child-item';
function PriceComponent(_a) {
    var price = _a.price, currency = _a.currency, priceIsZeroLabel = _a.priceIsZeroLabel, discountText = _a.discountText;
    var _b, _c;
    var originalPrice = price.value.centAmount;
    var discountedPrice = (_b = price.discounted) === null || _b === void 0 ? void 0 : _b.value.centAmount;
    if (originalPrice === 0) {
        return createElement("span", null, priceIsZeroLabel);
    }
    if (discountedPrice === 0 && discountText && (discountText === null || discountText === void 0 ? void 0 : discountText.length) > 0) {
        return createElement("span", null, discountText);
    }
    return (createElement(PriceTag, { originalPrice: price.value.centAmount, discountedPrice: (_c = price.discounted) === null || _c === void 0 ? void 0 : _c.value.centAmount, currency: currency }));
}
var PrescriptionGlassesBundleChildItem = function (props) {
    var label = props.label, value = props.value;
    return (createElement("div", { className: classPrefix + "__row" },
        createElement("div", { className: classPrefix + "__row-item" },
            createElement("span", { className: classPrefix + "__label" },
                label,
                ": "),
            " ",
            value),
        createElement("span", { className: classPrefix + "__price" },
            createElement(PriceComponent, __assign({}, props)))));
};

var GoogleMapsContext = React__default.createContext({});
var useGoogleMapsContext = function () { return React__default.useContext(GoogleMapsContext); };
function GoogleMapsProvider(_a) {
    var settings = _a.settings, children = _a.children;
    return React__default.createElement(GoogleMapsContext.Provider, { value: settings }, children);
}
function withGoogleMaps(Component) {
    var wrappedName = Component.displayName || Component.name || 'Component';
    var WithGoogleMaps = function (props) { return (React__default.createElement(GoogleMapsContext.Consumer, null, function (context) { return React__default.createElement(Component, __assign({}, props, { googleMapsSettings: context })); })); };
    WithGoogleMaps.displayName = "WithGoogleMaps(" + wrappedName + ")";
    return WithGoogleMaps;
}

var getSvgString = function (width, height, theme) {
    return "<svg width=\"" + width + "px\" height=\"" + height + "px\" viewBox=\"0 0 27 39\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M27 13.4727C27 20.9135 15.1096 39 13.5 39C11.8904 39 0 20.9135 0 13.4727C0 6.03195 6.04416 0 13.5 0C20.9558 0 27 6.03195 27 13.4727Z\" fill=\"" + theme.background + "\"/><ellipse cx=\"13.5003\" cy=\"14.1813\" rx=\"6.39474\" ry=\"6.38182\" fill=\"" + theme.foreground + "\"/></svg>";
};
var Pin = function (_a) {
    var _b = _a.width, defaultWidth = _b === void 0 ? 27 : _b, _c = _a.height, defaultHeight = _c === void 0 ? 39 : _c, themes = _a.themes;
    return function (props) {
        var primaryTheme = themes.primary, highlightTheme = themes.highlight;
        var _a = props.highlight, highlight = _a === void 0 ? false : _a;
        var theme = highlight && highlightTheme ? highlightTheme : primaryTheme;
        var width = theme.width || defaultWidth;
        var height = theme.height || defaultHeight;
        var anchor = new google.maps.Point(Math.round(width / 2), height);
        var size = new google.maps.Size(width, height);
        var svgString = getSvgString(width, height, theme);
        return {
            url: "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgString),
            anchor: anchor,
            size: size,
            scaledSize: size,
        };
    };
};

var LoaderScreen = function (_a) {
    var _b = _a.height, height = _b === void 0 ? 75 : _b, delay = _a.delay, className = _a.className;
    var _c = __read(useState(true), 2), hasTimeoutPassed = _c[0], setHasTimeoutPassed = _c[1];
    var intl = useIntl();
    useEffect(function () {
        if (delay) {
            setHasTimeoutPassed(false);
            var timeout_1 = setTimeout(function () {
                setHasTimeoutPassed(true);
            }, delay);
            return function () { return clearTimeout(timeout_1); };
        }
    }, [delay]);
    return hasTimeoutPassed ? (createElement("div", { "data-t": "loader-screen", className: classnames('loader-screen', className), style: { height: height + "vh" }, "aria-busy": true },
        createElement("div", { className: "loader-screen__content" },
            createElement(Loader, null),
            createElement("p", { className: "loader-screen__text" }, intl.getLabel('common.loadingText'))))) : null;
};

var hashPosition = function (_a) {
    var position = _a.position;
    return position.lat + "," + position.lng;
};
var isEqualPositions = function (a, b) {
    var e_1, _a;
    if (a === b) {
        return true;
    }
    if (a.length !== b.length) {
        return false;
    }
    var hashes = a.map(hashPosition);
    try {
        for (var b_1 = __values(b), b_1_1 = b_1.next(); !b_1_1.done; b_1_1 = b_1.next()) {
            var item = b_1_1.value;
            var index = hashes.indexOf(hashPosition(item));
            if (index === -1) {
                return false;
            }
            hashes.splice(index, 1);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (b_1_1 && !b_1_1.done && (_a = b_1.return)) _a.call(b_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
};

var CustomMarker = function (_a) {
    var _b = _a.highlight, highlight = _b === void 0 ? false : _b, _c = _a.isUserMarker, isUserMarker = _c === void 0 ? false : _c, icon = _a.icon, infoWindow = _a.infoWindow, rest = __rest(_a, ["highlight", "isUserMarker", "icon", "infoWindow"]);
    return isUserMarker ? (
    // For the user location marker, we want the default GM marker to make it stand out
    React__default.createElement(Marker, __assign({}, rest))) : (React__default.createElement(Marker, __assign({}, rest, { icon: useCustomIcon(icon, highlight) }), infoWindow));
};
var useCustomIcon = function (icon, highlight) {
    return React__default.useMemo(function () { return (typeof icon === 'function' ? icon({ highlight: highlight }) : icon); }, [icon, highlight]);
};

var MAX_MARKERS_AMOUNT = 50;
var MIN_ZOOM_LEVEL = 14;
var GoogleMaps = function (_a) {
    var _b = _a.showUseMyLocation, showUseMyLocation = _b === void 0 ? false : _b, onClickUseMyLocation = _a.onClickUseMyLocation, userLocation = _a.userLocation, highlight = _a.highlight, markers = _a.markers, onMarkerClick = _a.onMarkerClick, onMarkerHover = _a.onMarkerHover, onMapClick = _a.onMapClick, mapOptions = _a.mapOptions, _c = _a.showLoader, showLoader = _c === void 0 ? true : _c, centerProp = _a.center, rest = __rest(_a, ["showUseMyLocation", "onClickUseMyLocation", "userLocation", "highlight", "markers", "onMarkerClick", "onMarkerHover", "onMapClick", "mapOptions", "showLoader", "center"]);
    var _d = useGoogleMapsContext(), apiKey = _d.apiKey, defaultZoom = _d.defaultZoom, defaultCenter = _d.defaultCenter, pin = _d.pin, markerClusterOptions = _d.markerClusterOptions;
    var mapRef = useRef();
    var _e = __read(useState({}), 2), markerRef = _e[0], setMarkerRef = _e[1];
    var _f = __read(useState(centerProp || defaultCenter), 2), center = _f[0], setCenter = _f[1];
    var _g = __read(useState(defaultZoom), 2), zoom = _g[0], setZoom = _g[1];
    var prevMarkers = usePrevious(markers);
    var options = __assign({ streetViewControl: false, fullscreenControl: false, mapTypeControl: false }, mapOptions);
    useEffect(function () { return setZoom(defaultZoom); }, [defaultZoom]);
    useEffect(function () { return centerProp && setCenter(centerProp); }, [centerProp]);
    useEffect(function () {
        if (prevMarkers && !isEqualPositions(prevMarkers, markers)) {
            fitMarkers();
        }
    }, [prevMarkers, markers]);
    useEffect(function () {
        highlight && handleMarkerClick(highlight);
        handleZoomChanged();
    }, [highlight]);
    var isLoaded = useLoadScript({
        googleMapsApiKey: apiKey,
    }).isLoaded;
    var onLoad = useCallback(function (map) {
        mapRef.current = map;
        // Note: this is omitted from the dependencies to avoid rerendering the map
        // every time the markers change. This could cause incorrect zoom/pan when
        // the markers change before onLoad, and then never again - which is very
        // unlikely. Updates after onLoad are handled by above via useEffect.
        fitMarkers();
    }, []);
    var onMarkerLoad = function (marker, code) {
        return code && setMarkerRef(function (prevState) {
            var _a;
            return (__assign(__assign({}, prevState), (_a = {}, _a[code] = marker, _a)));
        });
    };
    var handleZoomChanged = useCallback(function () { return mapRef.current && setZoom(mapRef.current.getZoom()); }, []);
    var onHover = useCallback(function (code, markerRef) { return onMarkerHover && onMarkerHover(code, markerRef[code]); }, [onMarkerHover]);
    var handleMapClick = useCallback(function (e) { return onMapClick && onMapClick(e); }, [onMapClick]);
    var handleUseMyLocationClick = useCallback(function () {
        onClickUseMyLocation && onClickUseMyLocation();
        userLocation && mapRef.current && handleCurrentPositionClick(userLocation);
    }, [userLocation]);
    var handleCurrentPositionClick = function (userLocation) {
        if (!userLocation || !mapRef.current) {
            return;
        }
        mapRef.current.panTo(userLocation);
        setZoom(14);
    };
    var handleMarkerClick = useCallback(function (code) {
        if (!code) {
            return;
        }
        var highlightPos = markers.find(function (marker) { return marker.code === code; });
        var newZoomLevel = Math.max(MIN_ZOOM_LEVEL, zoom);
        if (mapRef.current && highlightPos) {
            mapRef.current.panTo(highlightPos.position);
        }
        setZoom(newZoomLevel);
        onMarkerClick && onMarkerClick(code);
    }, [onMarkerClick]);
    var fitMarkers = function () {
        var _a;
        // When there are no markers or too many markers, zoom out to the default zoom
        if (!markers.length || markers.length > MAX_MARKERS_AMOUNT) {
            setZoom(defaultZoom);
            setCenter(center || defaultCenter);
        }
        // Otherwise, automatically reposition the map to show all markers (if map is ready)
        else if (mapRef.current) {
            var bounds = markers.reduce(function (newBounds, marker) { return newBounds.extend(marker.position); }, new google.maps.LatLngBounds());
            (_a = mapRef.current) === null || _a === void 0 ? void 0 : _a.fitBounds(bounds);
        }
    };
    var renderMarkers = function (clusterer) {
        return markers
            .filter(function (marker) { return !(marker.position.lat === 0 && marker.position.lng === 0); })
            .map(function (marker, index) { return (createElement(CustomMarker, { key: marker.code + "-" + index, position: marker.position, clusterer: clusterer, onClick: function () { return handleMarkerClick(marker.code); }, highlight: marker.code === highlight, isUserMarker: marker.isUserLocation, icon: marker.pin || pin, infoWindow: marker.infoWindow, onLoad: function (mapsMarker) { return onMarkerLoad(mapsMarker, marker.code); }, onMouseOver: function () { return onHover(marker.code, markerRef); }, onMouseOut: function () { return onHover(null, markerRef); } })); });
    };
    if (!isLoaded) {
        return showLoader ? createElement(LoaderScreen, null) : null;
    }
    return (createElement(GoogleMap, { mapContainerClassName: "google-maps__container", options: options, onLoad: onLoad, onClick: handleMapClick, onZoomChanged: handleZoomChanged, zoom: zoom, center: center },
        markerClusterOptions ? (createElement(MarkerClusterer, __assign({}, markerClusterOptions), function (clusterer) { return renderMarkers(clusterer); })) : (renderMarkers()),
        showUseMyLocation && onClickUseMyLocation && (createElement("button", { className: "google-maps__center-position-button", onClick: handleUseMyLocationClick },
            createElement(Icon, { name: "gps" })))));
};

var IconButton = forwardRef(function (_a, ref) {
    var outline = _a.outline, disabled = _a.disabled, onClick = _a.onClick, className = _a.className, children = _a.children, rest = __rest(_a, ["outline", "disabled", "onClick", "className", "children"]);
    if (!children) {
        return null;
    }
    return (createElement("button", __assign({}, rest, { className: classnames('icon-button', {
            'icon-button--outline': outline,
        }, className), onClick: onClick, disabled: disabled || false, ref: ref }), children));
});
IconButton.displayName = 'IconButton';

var useResizeEventListener = function (iframeId, iframeRef, setHeight, iframeHeight, initialHeight) {
    var iframeEventHandler = useCallback(function (e) {
        if (initialHeight || !Array.isArray(e.data)) {
            return;
        }
        var _a = __read(e.data, 3), eventName = _a[0], eventValue = _a[1], eventIframeId = _a[2];
        if (iframeId !== eventIframeId) {
            return;
        }
        if (eventName === 'setHeight' && iframeHeight !== eventValue) {
            setHeight(eventValue);
        }
        else if (eventName === 'scrollTop' && iframeRef.current) {
            iframeRef.current.scrollIntoView();
            window.scrollBy(0, -100);
        }
    }, [initialHeight, iframeHeight, iframeId, iframeRef]);
    useEventListener('message', iframeEventHandler);
};
var IFrame = function (_a) {
    var _b;
    var source = _a.source, initialHeight = _a.height, scrolling = _a.scrolling, _c = _a.position, position = _c === void 0 ? 'center' : _c;
    if (!source) {
        return null;
    }
    var _d = __read(useState(initialHeight), 2), iframeHeight = _d[0], setHeight = _d[1];
    var iframeId = get(QueryString.parse(source), 'iframeId', '');
    var iframeRef = useRef(null);
    useResizeEventListener(StringGuard.guard('iframeId', iframeId), iframeRef, setHeight, iframeHeight, initialHeight);
    return (createElement("div", { className: "site-container" },
        createElement("div", { className: classnames('iframe', (_b = {}, _b["iframe--" + position] = !!position, _b)) },
            createElement("iframe", { ref: iframeRef, frameBorder: "0", src: source, height: iframeHeight, scrolling: "" + (scrolling ? 'yes' : 'no') }))));
};

var Image = /** @class */ (function (_super) {
    __extends(Image, _super);
    function Image() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            q: (_this.props.lazyLoadingOptions && _this.props.lazyLoadingOptions.q) || '',
            auto: (_this.props.lazyLoadingOptions && _this.props.lazyLoadingOptions.auto) || '',
        };
        _this.renderImage = function (lazyLoadingUrl, _a) {
            var lazyLoadingOptions = _a.lazyLoadingOptions, cover = _a.cover, alt = _a.alt, rest = __rest(_a, ["lazyLoadingOptions", "cover", "alt"]);
            return (createElement("span", { className: "image__background-image", role: "img", "aria-label": Boolean(rest['aria-hidden']) ? undefined : alt, "aria-hidden": rest['aria-hidden'], style: {
                    backgroundImage: "url('" + lazyLoadingUrl + "')",
                    backgroundSize: "" + (cover ? 'cover' : 'contain'),
                } }));
        };
        return _this;
    }
    Image.prototype.componentDidMount = function () {
        var lazyLoadingOptions = this.props.lazyLoadingOptions;
        if (lazyLoadingOptions) {
            // Set the image quality back to default from a low quality image state
            this.setState({
                q: '',
                auto: '',
            });
        }
    };
    Image.prototype.render = function () {
        var _a = this.props, url = _a.url, onClick = _a.onClick, className = _a.className, children = _a.children;
        var _b = this.state, q = _b.q, auto = _b.auto;
        var urlOptionQuality = q && "&q=" + q;
        var urlOptionAutomatic = auto && "&auto=" + auto;
        var lazyLoadingUrl = url + urlOptionQuality + urlOptionAutomatic;
        return onClick ? (createElement("button", { className: classnames('image', className), onClick: onClick }, this.renderImage(lazyLoadingUrl, this.props))) : (createElement("div", { className: classnames('image', className) },
            this.renderImage(lazyLoadingUrl, this.props),
            children));
    };
    return Image;
}(PureComponent));

var LazyImage = function (_a) {
    var src = _a.src, alt = _a.alt, className = _a.className, width = _a.width, height = _a.height, _b = _a.rootMargin, rootMargin = _b === void 0 ? '0px 0px' : _b, srcSet = _a.srcSet, sizes = _a.sizes, placeholder = _a.placeholder;
    if (!src || !width || !height) {
        console.warn('Width and height are required when using LazyImage');
        return null;
    }
    var _c = __read(useInView({
        rootMargin: rootMargin,
        triggerOnce: true,
    }), 2), ref = _c[0], inView = _c[1];
    var renderImage = function () {
        return srcSet && sizes ? (createElement(ResponsiveImage, { alt: alt, src: src, srcSet: srcSet, sizes: sizes })) : (createElement("img", { src: src, alt: alt, width: width, height: height }));
    };
    return (createElement("div", { ref: ref, className: classnames('lazy-image', className), style: { paddingBottom: (height / width) * 100 + "%" } }, inView ? renderImage() : placeholder || null));
};

var LineItem = forwardRef(function (_a, ref) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React__default.createElement("div", __assign({}, rest, { className: classnames('elements-line-item', className), ref: ref })));
});
LineItem.displayName = 'LineItem';

var priceBaseClassName = 'elements-line-item-aside__price';
var LineItemAside = forwardRef(function (_a, ref) {
    var _b;
    var children = _a.children, className = _a.className, currency = _a.currency, discountPrice = _a.discountPrice, price = _a.price, rest = __rest(_a, ["children", "className", "currency", "discountPrice", "price"]);
    var getLabel = useIntl().getLabel;
    var content = children;
    if (discountPrice === 0) {
        content = (React__default.createElement("p", { className: priceBaseClassName },
            React__default.createElement("span", { className: "price" }, getLabel('products.freeProduct'))));
    }
    else if (!children && price) {
        var classNames_1 = classnames(priceBaseClassName, (_b = {},
            _b[priceBaseClassName + "--strikethrough"] = typeof discountPrice === 'number',
            _b));
        content = (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("p", { className: classNames_1 },
                React__default.createElement(Price, { value: price, currency: currency })),
            discountPrice && (React__default.createElement(React__default.Fragment, null,
                "\u00A0",
                React__default.createElement("p", { className: priceBaseClassName },
                    React__default.createElement(Price, { value: discountPrice, currency: currency }))))));
    }
    return (React__default.createElement("div", __assign({}, rest, { className: classnames('elements-line-item-aside', className), ref: ref }), content));
});
LineItemAside.displayName = 'LineItemAside';

var LineItemContent = forwardRef(function (_a, ref) {
    var body = _a.body, children = _a.children, className = _a.className, title = _a.title, rest = __rest(_a, ["body", "children", "className", "title"]);
    var content = children;
    if (!content) {
        content = (React__default.createElement(React__default.Fragment, null,
            React__default.createElement("h4", { className: "elements-line-item-content__title" }, title),
            React__default.createElement("div", { className: "elements-line-item-content__body" }, body)));
    }
    return (React__default.createElement("div", __assign({}, rest, { className: classnames('elements-line-item-content', className), ref: ref }), content));
});
LineItemContent.displayName = 'LineItemContent';

var LineItemDeleteButton = function (_a) {
    var className = _a.className, onClick = _a.onClick, rest = __rest(_a, ["className", "onClick"]);
    var getLabel = useIntl().getLabel;
    return (createElement(IconButton, { onClick: onClick, "data-t": rest['data-t'], className: classnames('elements-line-item-delete', className), "aria-label": getLabel('common.actions.delete') },
        createElement(Icon, { className: "elements-line-item-delete__icon", name: "trash" })));
};

var lineItemClassName = 'line-item-glasses-prescription';
var Row = function (_a) {
    var prescriptionAttributes = _a.prescriptionAttributes;
    var getLabel = useIntl().getLabel;
    var sortedParams = sortPrescriptionParameters(Object.keys(prescriptionAttributes));
    return (createElement(Fragment, null, sortedParams.map(function (key) { return (createElement("span", { className: lineItemClassName + "__item", key: key },
        getLabel("cart.lineItem.glasses.prescription." + key),
        ":",
        ' ',
        PrescriptionValueUtils.formatPrescriptionValue(key, prescriptionAttributes[key]))); })));
};
var Wrapper$1 = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (createElement("div", { className: classnames(lineItemClassName, className), "data-t": rest['data-t'] }, children));
};
var NewPrescriptionDetails = function (_a) {
    var rightLens = _a.rightLens, leftLens = _a.leftLens;
    var getLabel = useIntl().getLabel;
    return (createElement(Fragment, null,
        createElement("div", { className: lineItemClassName + "__group" },
            createElement("span", { className: lineItemClassName + "__item " + lineItemClassName + "__title" },
                getLabel('common.right'),
                ":",
                ' '),
            createElement(Row, { prescriptionAttributes: rightLens })),
        createElement("div", { className: lineItemClassName + "__group" },
            createElement("span", { className: lineItemClassName + "__item " + lineItemClassName + "__title" },
                getLabel('common.left'),
                ":",
                ' '),
            createElement(Row, { prescriptionAttributes: leftLens }))));
};
var PrescriptionMessage = function (_a) {
    var prescription = _a.prescription;
    var getLabel = useIntl().getLabel;
    var labelKey = CommerceToolsApi.isExistingCustomer(prescription)
        ? 'noPrescription'
        : 'emailPrescription';
    return (createElement("div", null,
        createElement("span", { className: lineItemClassName + "__title" },
            getLabel("cart.lineItem.glasses." + labelKey + ".title"),
            ":",
            ' '),
        getLabel("cart.lineItem.glasses." + labelKey + ".message")));
};
var LineItemGlassesPrescription = function (_a) {
    var prescription = _a.prescription, className = _a.className, rest = __rest(_a, ["prescription", "className"]);
    var wrapperProps = {
        className: className,
        'data-t': rest['data-t'],
    };
    if (CommerceToolsApi.isNewPrescription(prescription)) {
        var rightLens = prescription.rightLens, leftLens = prescription.leftLens;
        return (createElement(Wrapper$1, __assign({}, wrapperProps),
            createElement(NewPrescriptionDetails, { rightLens: rightLens, leftLens: leftLens })));
    }
    if (CommerceToolsApi.isExistingCustomer(prescription) ||
        CommerceToolsApi.isEmailPrescription(prescription)) {
        return (createElement(Wrapper$1, __assign({}, wrapperProps),
            createElement(PrescriptionMessage, { prescription: prescription })));
    }
    return null;
};

var addLinkToComponent = function (component, href) {
    if (href) {
        return (React__default.createElement("a", { className: "elements-line-item-media__link", href: href }, component));
    }
    return component;
};
var LineItemMedia = forwardRef(function (_a, ref) {
    var _b;
    var href = _a.href, children = _a.children, className = _a.className, imageUrl = _a.imageUrl, imageAlt = _a.imageAlt, iconName = _a.iconName, iconLabel = _a.iconLabel, type = _a.type, overlayElement = _a.overlayElement, width = _a.width, rest = __rest(_a, ["href", "children", "className", "imageUrl", "imageAlt", "iconName", "iconLabel", "type", "overlayElement", "width"]);
    var containerClasses = classnames('elements-line-item-media__container', {
        'elements-line-item-media__container--with-overlay': !!overlayElement,
    });
    var content = children;
    if (!content) {
        if (type === 'image') {
            content = (React__default.createElement("div", { className: containerClasses },
                React__default.createElement("img", { className: classnames('elements-line-item-media__image', (_b = {},
                        _b["elements-line-item-media__image--" + width] = width,
                        _b)), src: imageUrl, alt: imageAlt })));
        }
        if (type === 'icon' && iconName) {
            content = (React__default.createElement("div", { className: containerClasses },
                React__default.createElement("div", { className: "elements-line-item-media__icon" },
                    React__default.createElement(Icon, { name: iconName, width: 48, height: 48 }),
                    !!iconLabel && (React__default.createElement("span", { className: "elements-line-item-media__icon-label" }, iconLabel)))));
        }
    }
    return (React__default.createElement("div", __assign({}, rest, { className: classnames('elements-line-item-media', className), ref: ref }), addLinkToComponent(content, href)));
});
LineItemMedia.displayName = 'LineItemMedia';

var LineItemSubtitle = function (_a) {
    var className = _a.className, subtitle = _a.subtitle;
    return (createElement("p", { className: classnames('elements-line-item-subtitle', className) }, subtitle));
};

var LineItemTitle = function (_a) {
    var className = _a.className, title = _a.title;
    return (createElement(Heading, { component: "h2", variant: "subheading1", className: classnames('elements-line-item-title', className) }, title));
};

var List = function (_a) {
    var items = _a.items, renderText = _a.renderText, _b = _a.type, type = _b === void 0 ? 'default' : _b, className = _a.className;
    if (items.length < 1) {
        return null;
    }
    var hasIcons = type !== 'default';
    var hasSmallIcons = type === null || type === void 0 ? void 0 : type.includes('-small');
    var iconSize = hasSmallIcons ? 18 : 24;
    return (createElement("ul", { "data-t": "list", className: classnames('list', className, {
            'list--with-icons': hasIcons,
            'list--with-small-icons': hasSmallIcons,
        }) }, items.map(function (item) { return (createElement("li", { key: item, className: "list__item list__item--" + type },
        type !== 'default' && (createElement(Icon, { name: "checkmark-circle", className: "list__item-icon", width: iconSize, height: iconSize })),
        renderText ? renderText(item) : createElement("span", { className: "list__item-text" }, item))); })));
};
List.displayName = 'List';

var LockBodyScroll = /** @class */ (function (_super) {
    __extends(LockBodyScroll, _super);
    function LockBodyScroll() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LockBodyScroll.prototype.componentDidMount = function () {
        lockScroll();
    };
    LockBodyScroll.prototype.componentWillUnmount = function () {
        unlockScroll();
    };
    LockBodyScroll.prototype.render = function () {
        return null;
    };
    return LockBodyScroll;
}(Component));

var Logo = function (_a) {
    var url = _a.url, className = _a.className, image = _a.image, title = _a.title, srOnlyText = _a.srOnlyText;
    return (createElement("a", { className: "logo " + (className || ''), href: url, title: title, "data-t": "logo-link" },
        createElement("img", { className: "logo__img", src: image.url, alt: image.altText, "data-t": "logo-image" }),
        srOnlyText && (createElement("span", { className: "sr-only", "data-t": "logo-sr-only" }, srOnlyText))));
};

var clusterSizes = [
    {
        width: 24,
        height: 25,
    },
    {
        width: 41,
        height: 42,
    },
    {
        width: 56,
        height: 58,
    },
    {
        width: 72,
        height: 74,
    },
    {
        width: 88,
        height: 90,
    },
];
var getSvgString$1 = function (width, height, color) {
    return "<svg width=\"" + width + "\" height=\"" + height + "\" viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"12\" cy=\"12.0569\" r=\"12\" fill=\"" + color + "\"/></svg>";
};
var markerClusterStyles = function (_a) {
    var theme = _a.theme, size = _a.size;
    var textSize = 12;
    var height = size.height;
    var width = size.width;
    var color = theme.color;
    var textColor = theme.textColor;
    var svgString = getSvgString$1(width, height, color);
    return {
        url: "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgString),
        width: width,
        height: height,
        textColor: textColor,
        textSize: textSize,
    };
};
var MarkerClusters = function (props) {
    var theme = props.theme, _a = props.maxZoom, maxZoom = _a === void 0 ? 10 : _a, _b = props.minimumClusterSize, minimumClusterSize = _b === void 0 ? 2 : _b;
    var styles = clusterSizes.map(function (clusterSize) {
        return markerClusterStyles({ size: clusterSize, theme: theme });
    });
    return {
        styles: styles,
        maxZoom: maxZoom,
        minimumClusterSize: minimumClusterSize,
    };
};

var Modal = function (_a) {
    var _b, _c, _d, _e;
    var ariaLabel = _a["aria-label"], _f = _a.isOpen, isOpen = _f === void 0 ? false : _f, _g = _a.isFullScreen, isFullScreen = _g === void 0 ? false : _g, _h = _a.useScrollLock, useScrollLock = _h === void 0 ? true : _h, className = _a.className, title = _a.title, footer = _a.footer, showIcon = _a.showIcon, secondaryIconOptions = _a.secondaryIconOptions, iconClassName = _a.iconClassName, onModalClose = _a.onModalClose, children = _a.children, rest = __rest(_a, ['aria-label', "isOpen", "isFullScreen", "useScrollLock", "className", "title", "footer", "showIcon", "secondaryIconOptions", "iconClassName", "onModalClose", "children"]);
    var _j = __read(useState(null), 2), modalRoot = _j[0], setModalRoot = _j[1];
    var _k = __read(useState(isOpen), 2), open = _k[0], setOpen = _k[1];
    var dialogRef = useRef(null);
    var getLabel = useIntl().getLabel;
    var hideModal = useCallback(function () {
        setOpen(false);
        useScrollLock && unlockScroll();
        onModalClose && onModalClose();
    }, [onModalClose, useScrollLock]);
    var hideOnEscKey = useCallback(function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
            hideModal();
        }
    }, [hideModal]);
    useEffect(function () {
        var _a;
        var focusedElement = document.activeElement;
        if (dialogRef.current && open && isOpen) {
            if (!focusedElement || !dialogRef.current.contains(focusedElement)) {
                (_a = dialogRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }
    }, [dialogRef.current, open, isOpen]);
    useEffect(function () {
        document.addEventListener('keydown', hideOnEscKey, false);
        return function () {
            document.removeEventListener('keydown', hideOnEscKey, false);
        };
    }, [hideOnEscKey]);
    useEffect(function () {
        if (isOpen !== open) {
            setOpen(isOpen);
        }
    }, [isOpen]);
    useEffect(function () {
        if (useScrollLock) {
            open ? lockScroll() : unlockScroll();
        }
        return function () {
            unlockScroll();
        };
    }, [open, useScrollLock]);
    useEffect(function () {
        setModalRoot(document ? document.body : null);
    }, []);
    var transition = {
        stiffness: 500,
    };
    var variants = {
        exit: {
            opacity: 0,
            y: 50,
        },
        idle: {
            opacity: 1,
            y: 0,
        },
    };
    return (modalRoot &&
        ReactDOM.createPortal(createElement(AnimatePresence, null, open && (createElement("div", { "data-t": rest['data-t'], className: classnames('modal', className) },
            createElement(Backdrop, { className: "modal__backdrop", onClick: hideModal, isVisible: open, animate: false }),
            createElement(motion.div, { transition: transition, variants: variants, initial: "exit", animate: "idle", exit: "exit", className: classnames('modal__body', (_b = {
                        'modal__body--flex': !!title || !!footer,
                        'modal__body--fullscreen': isFullScreen
                    },
                    _b[className + "__body"] = !!className,
                    _b)), "data-t": "modal-body", "aria-label": ariaLabel || title, role: "dialog", "aria-modal": "true", tabIndex: -1, ref: dialogRef },
                secondaryIconOptions && (createElement(IconButton, { "aria-label": secondaryIconOptions['aria-label'], className: "modal__secondary-icon", onClick: secondaryIconOptions.onClick },
                    createElement(Icon, { name: secondaryIconOptions.name }))),
                showIcon && (createElement(IconButton, { className: classnames('modal__close', iconClassName), "aria-label": getLabel('common.actions.close'), onClick: hideModal },
                    createElement(Icon, { name: "close" }))),
                title && (createElement("header", { className: classnames('modal__header', (_c = {}, _c[className + "__header"] = !!className, _c)) },
                    createElement("h2", { className: "modal__title h4" }, title),
                    createElement(Hr, null))),
                createElement("div", { className: classnames('modal__content', (_d = {}, _d[className + "__content"] = !!className, _d)) }, children),
                footer && (createElement("footer", { className: classnames('modal__footer', (_e = {}, _e[className + "__footer"] = !!className, _e)) },
                    createElement(Hr, null),
                    footer)))))), modalRoot));
};

var NotificationBar = function (_a) {
    var title = _a.title, description = _a.description, _b = _a.theme, theme = _b === void 0 ? 'dark' : _b, _c = _a.link, link = _c === void 0 ? {} : _c;
    var getLabel = useIntl().getLabel;
    var _d = __read(useState(false), 2), isHidden = _d[0], setIsHidden = _d[1];
    var handleClose = useCallback(function () { return setIsHidden(true); }, []);
    if (isHidden) {
        return null;
    }
    return (createElement("div", { className: "notification-bar notification-bar--" + theme },
        createElement("div", { className: "notification-bar__container" },
            title && createElement("h4", { className: "notification-bar__title" }, title),
            description && (createElement(Fragment, null,
                createElement("span", { className: "notification-bar__separator" }, "-"),
                createElement("p", { className: "notification-bar__description" }, description))),
            link.url && link.label && (createElement(Link, { className: "notification-bar__link", url: link.url, label: link.label, target: link.target })),
            createElement("button", { className: "notification-bar__close-icon", "aria-label": getLabel('common.actions.close'), onClick: handleClose },
                createElement(Icon, { name: "close" })))));
};

var OlapicContext = React__default.createContext('');
var OlapicProvider = function (_a) {
    var sku = _a.sku, children = _a.children;
    return (React__default.createElement(OlapicContext.Provider, { value: sku }, children));
};
var useOlapicContext = function () { return React__default.useContext(OlapicContext); };

var Olapic = function (_a) {
    var apiKey = _a.apiKey, instance = _a.instance, locale = _a.locale, olapic = _a.olapic, src = _a.src, tags = _a.tags;
    var sku = useOlapicContext();
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("div", { id: olapic }),
        React__default.createElement("script", { type: "text/javascript", defer: true, src: src, "data-instance": instance, "data-apikey": apiKey, "data-olapic": olapic, "data-tags": sku || tags, "data-lang": locale, "data-use-opi": "false" })));
};

var renderProgressBar = function (max, value) { return (createElement("progress", { className: "progress-bar__value", max: max, value: value }, value && value + "%")); };
var ProgressBar = function (_a) {
    var label = _a.label, max = _a.max, value = _a.value, className = _a.className;
    return (createElement("div", { className: classnames('progress-bar', className) }, label ? (createElement("label", { className: "progress-bar__label" },
        label,
        renderProgressBar(max, value))) : (renderProgressBar(max, value))));
};

var QuantitySelector = function (props) {
    var quantity = props.quantity, onDecreaseQuantity = props.onDecreaseQuantity, onIncreaseQuantity = props.onIncreaseQuantity, _a = props.minimumQuantity, minimumQuantity = _a === void 0 ? 1 : _a, maximumQuantity = props.maximumQuantity, _b = props.isDisabled, isDisabled = _b === void 0 ? false : _b;
    var getLabel = useIntl().getLabel;
    return (createElement("div", { className: "quantity-selector", "data-t": props['data-t'] },
        createElement(IconButton, { "aria-label": getLabel('cart.item.quantity.decrement'), className: "quantity-selector__button quantity-selector__button--minus", disabled: quantity === minimumQuantity || isDisabled, onClick: onDecreaseQuantity },
            createElement(Icon, { name: "minus" })),
        createElement("div", { className: "quantity-selector__amount" }, quantity),
        createElement(IconButton, { "aria-label": getLabel('cart.item.quantity.increment'), className: "quantity-selector__button quantity-selector__button--plus", disabled: (maximumQuantity && quantity >= maximumQuantity) || isDisabled, onClick: onIncreaseQuantity },
            createElement(Icon, { name: "plus" }))));
};

var RadioButton = function (_a) {
    var name = _a.name, _b = _a.variant, variant = _b === void 0 ? 'outline' : _b, // TODO: change to "plain" when all occurrences are fixed and we want to do a BREAKING release
    children = _a.children, className = _a.className, _c = _a.disabled, disabled = _c === void 0 ? false : _c, isChecked = _a.isChecked, onChange = _a.onChange, _d = _a.position, position = _d === void 0 ? 'left' : _d, value = _a.value, id = _a.id, dataT = _a["data-t"], rest = __rest(_a, ["name", "variant", "children", "className", "disabled", "isChecked", "onChange", "position", "value", "id", 'data-t']);
    return (createElement("label", __assign({ htmlFor: id || value, className: classnames('radio-button', "radio-button--" + variant, "radio-button--" + position, className), "data-t": dataT }, rest),
        createElement("input", { type: "radio", name: name || 'radio-button', id: id || value, "aria-checked": isChecked, checked: isChecked, disabled: disabled, onChange: onChange, value: value, className: "radio-button__input" }),
        variant === 'outline' ? (createElement(Card, { className: "radio-button__label" }, children)) : (createElement("div", { className: "radio-button__label" }, children)),
        createElement("div", { className: "radio-button__radio-indicator" })));
};

var variants$1 = {
    enter: function (_a) {
        var index = _a.index;
        return ({
            y: 0,
            opacity: 1,
            transition: {
                delay: index * 0.05,
                duration: 0.2,
                ease: 'easeIn',
            },
        });
    },
    exit: {
        y: 10,
        opacity: 0,
    },
};
var RadioButtonGroup = /** @class */ (function (_super) {
    __extends(RadioButtonGroup, _super);
    function RadioButtonGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: typeof _this.props.value !== 'undefined' ? _this.props.value : _this.props.initialValue || '',
        };
        _this.handleChange = function (event) {
            var value = event.currentTarget.value;
            _this.setState({ value: value });
            _this.props.onChange && _this.props.onChange(value);
        };
        return _this;
    }
    RadioButtonGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, items = _a.items, scope = _a.scope, className = _a.className;
        var classNames = classnames('radio-button-group', className);
        return (createElement("ul", { className: classNames, "data-t": this.props['data-t'], role: "radiogroup" },
            createElement(AnimatePresence, null, items.length > 0 &&
                items.map(function (item, index) { return (createElement(motion.li, { className: "radio-button-group__item", key: item.value, custom: { index: index }, variants: variants$1, initial: "exit", animate: "enter" },
                    createElement("label", { className: classnames('radio-button-group__label', {
                            'radio-button-group__label--disabled': item.disabled,
                            'radio-button-group__label--checked': item.value === _this.state.value,
                        }), role: "radio", "aria-checked": item.value === _this.state.value },
                        createElement("input", { className: "radio-button-group__input", name: scope, type: "radio", value: item.value, checked: item.value === _this.state.value, "aria-checked": item.value === _this.state.value, disabled: item.disabled, onChange: _this.handleChange }),
                        createElement("div", { className: classnames('radio-button-group__radio', {
                                'radio-button-group__radio--disabled': item.disabled,
                                'radio-button-group__radio--checked': item.value === _this.state.value,
                            }) }),
                        createElement("div", { className: "radio-button-group__text" },
                            createElement("span", null, item.label),
                            item.subtext && (createElement("span", { className: "radio-button-group__subtext" }, item.subtext)),
                            item.aside && createElement("span", { className: "radio-button-group__aside" }, item.aside))))); }))));
    };
    RadioButtonGroup.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.value !== prevProps.value) {
            this.setState({ value: this.props.value || '' });
        }
    };
    return RadioButtonGroup;
}(Component));

var RangeSlider = /** @class */ (function (_super) {
    __extends(RangeSlider, _super);
    function RangeSlider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (value) {
            var state = {
                facet: _this.props.facet,
                value: "range(" + value[0] * 100 + " to " + value[1] * 100 + ")",
            };
            _this.props.onChange(state);
        };
        return _this;
    }
    RangeSlider.prototype.render = function () {
        var _a = this.props, min = _a.min, max = _a.max, initialValues = _a.initialValues, currency = _a.currency;
        return (React__default.createElement(SimpleRangeSlider, { min: min, max: max, defaultValue: initialValues, onAfterChange: this.onChange, currency: currency }));
    };
    RangeSlider.defaultProps = {
        min: 0,
        max: 600,
        initialValues: [0, 600],
    };
    return RangeSlider;
}(React__default.Component));
function SimpleRangeSlider(_a) {
    var min = _a.min, max = _a.max, _b = _a.defaultValue, defaultValue = _b === void 0 ? [] : _b, value = _a.value, onChange = _a.onChange, onAfterChange = _a.onAfterChange, currency = _a.currency, _c = _a.renderNumber, renderNumber = _c === void 0 ? function (v) { return v; } : _c;
    var _d = __read(useState(0), 2), offset = _d[0], setOffset = _d[1];
    var firstHandleRef = useRef(null);
    var secondHandleRef = useRef(null);
    useLayoutEffect(checkCollision, []);
    var valueOrDefaultValue = value ? { value: value } : { defaultValue: defaultValue };
    return (React__default.createElement("div", { className: "range-slider" },
        React__default.createElement(Range, __assign({}, valueOrDefaultValue, { min: min, max: max, handle: renderHandle, onAfterChange: onAfterChange, onChange: handleChange, allowCross: false }))));
    function renderHandle(_a) {
        var value = _a.value, dragging = _a.dragging, index = _a.index, className = _a.className, restProps = __rest(_a, ["value", "dragging", "index", "className"]);
        var collider;
        var offsetStyle;
        if (className && className.includes('1')) {
            collider = firstHandleRef;
            offsetStyle = { left: offset * -1 };
        }
        else if (className && className.includes('2')) {
            collider = secondHandleRef;
            offsetStyle = { right: offset * -1 - 10 };
        }
        return (React__default.createElement(Handle, __assign({ key: index, value: value, dragging: "false", className: className }, restProps),
            React__default.createElement("div", { ref: collider, className: "tooltip tooltip--collider", style: offsetStyle }),
            React__default.createElement("div", { className: "tooltip tooltip--label", style: offsetStyle }, currency ? (React__default.createElement(Price, { value: renderNumber(value), currency: currency, centAmount: false })) : (renderNumber(value)))));
    }
    function handleChange(value) {
        onChange && onChange(value);
        checkCollision();
    }
    function checkCollision() {
        if (firstHandleRef.current && secondHandleRef.current) {
            var firstHandle = firstHandleRef.current.getBoundingClientRect();
            var secondHandle = secondHandleRef.current.getBoundingClientRect();
            if (firstHandle.right > secondHandle.left) {
                setOffset((firstHandle.right - secondHandle.left) / 2);
            }
            else {
                setOffset(0);
            }
        }
    }
}

var regHex = /#([a-f0-9]{3}){1,2}\b/i;
var regPresetBg = /black|grey|white/;
var RichTextArea = function (_a) {
    var content = _a.content, className = _a.className, _b = _a.textColor, textColor = _b === void 0 ? 'black' : _b, _c = _a.backgroundColor, backgroundColor = _c === void 0 ? 'transparent' : _c;
    var classNames = classnames('rich-text-area', "rich-text-area--text-" + textColor, className);
    var richTextAreaStyle = {
        backgroundColor: regHex.test(backgroundColor)
            ? backgroundColor
            : regPresetBg.test(backgroundColor)
                ? colorHexMap[backgroundColor]
                : 'transparent',
    };
    return (createElement("div", { className: classNames, style: richTextAreaStyle }, ReactHtmlParser(content)));
};

/**
 * By setting the key attribute on this component and changing the value, you can re-mount this component
 * and trigger componentDidMount to have it scroll to the element again. Example:
 * <ScrollIntoView key={changingValue}><Child /></ScrollIntoView>
 */
var ScrollIntoView = /** @class */ (function (_super) {
    __extends(ScrollIntoView, _super);
    function ScrollIntoView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.innerRef = createRef();
        _this.scrollToRef = function () {
            var node = _this.innerRef.current;
            if (!node) {
                return;
            }
            var currentBreakpoint = _this.props.currentBreakpoint;
            var isMobile = currentBreakpoint === BreakpointName.PHONE ||
                currentBreakpoint === BreakpointName.TABLET_PORTRAIT;
            // We assign this fixed height as the biggest we can expect the header
            // the visibility of the cookiebar is with this number taken into account
            var headerHeight = isMobile ? 66 : 150;
            var _a = node.getBoundingClientRect(), elementTopPos = _a.top, elementBottomPos = _a.bottom;
            /**
             * If both the top and bottom of the element are IN the viewport, meaning the
             * entire element is in view, we DON'T want to scroll
             *
             * If both the top and bottom of the element are OUT of the viewport, meaning the
             * element is bigger than the entire viewport, we DON'T want to scroll
             *
             * If the element could possibly be (partially) behind the header, we WANT to scroll
             */
            var viewportHeight = window.innerHeight;
            var topInView = elementTopPos > headerHeight && elementTopPos < viewportHeight;
            var bottomInView = elementBottomPos > headerHeight && elementBottomPos < viewportHeight;
            var spansViewport = elementTopPos < 0 && elementBottomPos > viewportHeight;
            var entirelyInViewport = topInView && bottomInView;
            if (spansViewport || entirelyInViewport) {
                return;
            }
            var distanceFromTop = elementTopPos - headerHeight;
            window.scrollBy({ top: distanceFromTop, behavior: 'smooth' });
        };
        return _this;
    }
    ScrollIntoView.prototype.componentDidMount = function () {
        /**
         * Need to call setTimeout here to defer the element position calculation to _after_ the
         * browser has finished painting the DOM and fix the race condition. This fixes the issue
         * in Firefox where element height would not be available yet at the time of the calculation.
         */
        setTimeout(this.scrollToRef, 0);
    };
    ScrollIntoView.prototype.render = function () {
        return (createElement("div", { className: "scroll-into-view", "data-t": "scroll-into-view", ref: this.innerRef }, this.props.children));
    };
    return ScrollIntoView;
}(Component));
var ScrollIntoView$1 = WithBreakpoints(ScrollIntoView);

var scrollUp = function (animationDuration, stopPosition) {
    var request;
    var cancelScrolling = function () {
        cancelAnimationFrame(request);
        window.removeEventListener('wheel', cancelScrolling);
        window.removeEventListener('touchstart', cancelScrolling);
    };
    var scroll = function () {
        var pos = window.pageYOffset;
        if (pos > stopPosition) {
            request = requestAnimationFrame(scroll);
            //when pos / animationDuration becomes smaller than 1, it will should round up to 1
            window.scrollTo(0, pos - Math.ceil(pos / animationDuration));
        }
        window.addEventListener('wheel', cancelScrolling);
        window.addEventListener('touchstart', cancelScrolling);
    };
    scroll();
};
var ScrollUpButton = function (_a) {
    var _b = _a.showPosition, showPosition = _b === void 0 ? 400 : _b, _c = _a.animationDuration, animationDuration = _c === void 0 ? 20 : _c, _d = _a.stopPosition, stopPosition = _d === void 0 ? 0 : _d;
    var _e = __read(useState(false), 2), show = _e[0], setShow = _e[1];
    useEffect(function () {
        toggleScrollTopButton();
    }, []);
    var handleClick = useCallback(function () {
        scrollUp(animationDuration, stopPosition);
    }, [animationDuration, stopPosition]);
    var toggleScrollTopButton = useCallback(function () {
        setShow(showPosition < window.pageYOffset);
    }, [showPosition]);
    useEventListener('scroll', toggleScrollTopButton);
    var classNames = classnames('scroll-to-top', { 'scroll-to-top--show': show });
    return (createElement("div", { role: "button", className: classNames, onClick: handleClick },
        createElement(Icon, { name: "chevron-up" })));
};

var SelectionGroupItem = function (_a) {
    var title = _a.title, text = _a.text, value = _a.value, scope = _a.scope, aside = _a.aside, handleChange = _a.handleChange, isChecked = _a.isChecked, disabled = _a.disabled;
    return (createElement("div", { className: "selection-group-item" },
        createElement("input", { className: "selection-group-item__input", name: scope, id: title, type: "radio", value: value, checked: isChecked, "aria-checked": isChecked, disabled: disabled || undefined, onChange: handleChange }),
        createElement("label", { className: "selection-group-item__label", htmlFor: title },
            createElement("div", { className: "selection-group-item__main" },
                createElement("h4", { className: "selection-group-item__title" }, title),
                text && createElement("span", { className: "selection-group-item__text" }, text)),
            aside && createElement("div", { className: "selection-group-item__aside" }, aside))));
};

var SelectionGroup = /** @class */ (function (_super) {
    __extends(SelectionGroup, _super);
    function SelectionGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: '',
        };
        _this.handleChange = function (event) {
            var value = event.currentTarget.value;
            _this.setState({ value: value });
            _this.props.onChange && _this.props.onChange(value);
        };
        return _this;
    }
    SelectionGroup.prototype.render = function () {
        var _this = this;
        var selectedItem = this.props.selectedItem;
        var items = this.props.items;
        if (!selectedItem) {
            selectedItem = items[0].value;
        }
        return (createElement("div", { className: "selection-group" }, items.map(function (item) { return (createElement(SelectionGroupItem, __assign({}, item, { key: item.value, isChecked: item.value === selectedItem, handleChange: _this.handleChange }))); })));
    };
    return SelectionGroup;
}(Component));

var DefaultShape = function () { return (createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", height: "220" },
    createElement("rect", { width: "100%", height: "100", rx: "5", fill: "currentColor" }),
    createElement("rect", { width: "80%", height: "15", rx: "5", fill: "currentColor", x: "10%", y: "140" }),
    createElement("rect", { width: "80%", height: "15", rx: "5", fill: "currentColor", x: "10%", y: "165" }),
    createElement("rect", { width: "50%", height: "15", rx: "5", fill: "currentColor", x: "25%", y: "200" }))); };
var SkeletonLoader = function (_a) {
    var _b = _a.animate, animate = _b === void 0 ? true : _b, className = _a.className, _c = _a.children, children = _c === void 0 ? createElement(DefaultShape, null) : _c, rest = __rest(_a, ["animate", "className", "children"]);
    return (createElement("div", __assign({ className: classnames('skeleton-loader', { 'skeleton-loader--animated': animate }, className) }, rest), children));
};

var Sticky = function (_a) {
    var children = _a.children, top = _a.top, bottomBoundary = _a.bottomBoundary, enabled = _a.enabled;
    return (createElement(StickyNode, { top: top, bottomBoundary: bottomBoundary, enabled: enabled }, children));
};

var StickyCallToAction = function (_a) {
    var price = _a.price, perBox = _a.perBox, button = _a.button;
    return (createElement("div", { className: classnames('sticky-call-to-action', { 'sticky-call-to-action--no-price': !price }) },
        price && (createElement("div", { className: "sticky-call-to-action__price-info" },
            createElement("div", { className: "sticky-call-to-action__price" }, price),
            perBox && createElement("span", { className: "sticky-call-to-action__per-box" }, perBox))),
        button));
};

var SummaryContainer = function (_a) {
    var children = _a.children, className = _a.className, rest = __rest(_a, ["children", "className"]);
    return (createElement("article", __assign({ className: classnames('summary__container', className) }, rest), children));
};

var Summary = function (_a) {
    var children = _a.children, onEditClick = _a.onEditClick, onDeleteClick = _a.onDeleteClick, _b = _a["data-t"], dataT = _b === void 0 ? 'summary' : _b, className = _a.className, editRef = _a.editRef;
    var withButtons = !!(onEditClick || onDeleteClick);
    return (createElement(SummaryContainer, { className: classnames('summary', className), "data-t": dataT },
        withButtons && (createElement("div", { className: "summary__buttons" },
            onEditClick && (createElement(IconButton, { className: "summary__button", "data-t": dataT + "-edit-button", onClick: onEditClick, ref: editRef },
                createElement(Icon, { name: "pencil", className: "summary__button-icon" }))),
            onDeleteClick && (createElement(IconButton, { className: "summary__button", "data-t": dataT + "-delete-button", onClick: onDeleteClick },
                createElement(Icon, { name: "trash", className: "summary__button-icon" }))))),
        children));
};

var joinData = function (values) { return values.filter(function (v) { return !!v; }).join(' '); };
var SummaryItem = function (value) {
    if (!value || (Array.isArray(value) && value.every(function (val) { return !val; }))) {
        return null;
    }
    return createElement("span", null, joinData(Array.isArray(value) ? value : [value]));
};

var SummaryLoader = function () { return (React__default.createElement(SummaryContainer, null,
    React__default.createElement(SkeletonLoader, null,
        React__default.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", height: "60px" },
            React__default.createElement("rect", { width: "200", height: "16px", rx: "4", fill: "currentColor" }),
            React__default.createElement("rect", { width: "180", height: "16px", rx: "4", fill: "currentColor", y: "32" }))))); };

var SupportFooter = function (_a) {
    var message = _a.message, phoneNumber = _a.phoneNumber, email = _a.email;
    return (createElement("div", { className: "support-footer" },
        createElement("h3", { className: "support-footer__title" }, ReactHtmlParser(message)),
        createElement("div", { className: "support-footer__contact-details" },
            phoneNumber && (createElement("a", { href: "tel:" + phoneNumber, className: "support-footer__link" },
                createElement(Icon, { name: "phone" }),
                createElement("span", { className: "support-footer__link-text" }, phoneNumber))),
            email && (createElement("a", { href: "mailto:" + email, className: "support-footer__link" },
                createElement(Icon, { name: "mail" }),
                createElement("span", { className: "support-footer__link-text" }, email))))));
};

var Tab = forwardRef(function (_a, ref) {
    var label = _a.label, onClick = _a.onClick, isActive = _a.isActive, className = _a.className, _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, rest = __rest(_a, ["label", "onClick", "isActive", "className", "variant"]);
    return (createElement("button", __assign({}, rest, { onClick: onClick, className: classnames("tab tab--" + variant, className, { _is_active: isActive }), "aria-pressed": isActive }), label));
});
Tab.displayName = 'Tab';

var Tooltip = function (_a) {
    var message = _a.message, id = _a.id, className = _a.className, _b = _a.placement, placement = _b === void 0 ? 'top' : _b, _c = _a.parseHtml, parseHtml = _c === void 0 ? false : _c, dashed = _a.dashed, label = _a.label, greyedOut = _a.greyedOut;
    if (!message) {
        return null;
    }
    var currentBreakpoint = useBreakpoint();
    var _d = __read(useState(false), 2), isActive = _d[0], setIsActive = _d[1];
    var _e = __read(useState(false), 2), tooltipHovered = _e[0], setTooltipHovered = _e[1];
    var isTouch = useMemo(function () { return isTouchDevice(); }, []);
    var triggerRef = useRef(null);
    // Touch device handlers
    var handleDocumentClick = useCallback(function (e) {
        // Check if the clicked target is not equal to our trigger, preventing the tooltip to re-open immediately
        setIsActive(function (isActive) {
            if (isActive && triggerRef.current && !triggerRef.current.contains(e.target)) {
                return false;
            }
            return isActive;
        });
    }, []);
    useEffect(function () {
        if (!isTouch) {
            return;
        }
        document.addEventListener('touchend', handleDocumentClick);
        return function () { return document.removeEventListener('touchend', handleDocumentClick); };
    }, [isTouch, handleDocumentClick]);
    var handleTriggerClick = useCallback(function () {
        isTouch && setIsActive(function (isActive) { return !isActive; });
    }, [isTouch]);
    // Non-touch handlers
    var handleTriggerMouseOver = useCallback(function () {
        !isTouch && setIsActive(true);
    }, [isTouch]);
    var handleTriggerMouseLeave = useCallback(function () {
        // this timeout allows a user to move it's cursor from the trigger to the tooltip to keep the tooltip open
        !isTouch && setTimeout(function () { return setIsActive(false); }, 100);
    }, [isTouch]);
    var handleTooltipMouseOver = useCallback(function () {
        !isTouch && setTooltipHovered(true);
    }, [isTouch]);
    var handleTooltipMouseLeave = useCallback(function () {
        !isTouch && setTooltipHovered(false);
    }, [isTouch]);
    var renderDashed = dashed &&
        (currentBreakpoint === BreakpointName.DESKTOP ||
            currentBreakpoint === BreakpointName.TABLET_LANDSCAPE);
    var buttonClass = classnames({
        tooltip__button: !renderDashed,
        'tooltip__button--active': isActive && !renderDashed,
        'tooltip__button--greyed-out': !dashed && greyedOut,
        tooltip__dashed: renderDashed,
    });
    return (createElement("div", { className: classnames('tooltip', className) },
        createElement(Manager, null,
            createElement(Reference, null, function (_a) {
                var ref = _a.ref;
                return (createElement("div", { ref: triggerRef },
                    createElement("div", { className: "tooltip__container" },
                        createElement("div", { "aria-label": "tooltip", className: buttonClass, role: "button", ref: ref, onClick: handleTriggerClick, onMouseOver: handleTriggerMouseOver, onMouseLeave: handleTriggerMouseLeave },
                            renderDashed && label,
                            !renderDashed && createElement(Icon, { name: "questionmark" })))));
            }),
            (isActive || tooltipHovered) && (createElement(Popper, { placement: placement, modifiers: {
                    preventOverflow: { enabled: true, boundariesElement: 'scrollParent', padding: 0 },
                } }, function (_a) {
                var ref = _a.ref, style = _a.style, placement = _a.placement;
                return (createElement("div", { "aria-label": "tooltip-message", id: id, ref: ref, style: style, role: "button", "data-placement": placement, className: "tooltip__message", onMouseOver: handleTooltipMouseOver, onMouseLeave: handleTooltipMouseLeave }, typeof message === 'string' ? (createElement("div", null, parseHtml ? ReactHtmlParser(message) : message)) : (isValidElement(message) && message)));
            })))));
};

var TOAST_INFO = 'TOAST/info';
var TOAST_SUCCESS = 'TOAST/success';
var TOAST_FAILED = 'TOAST/failed';
var TOAST_WARNING = 'TOAST/warning';
var buildContent = function (name, label) {
    return (createElement(Fragment, null,
        createElement(Icon, { className: "Toastify__toast-icon", name: name }),
        createElement("span", { className: "Toastify__toast-label" }, label)));
};
var toastService = function () {
    var labels = {};
    var showToast = function (type) { return function (labelKey, labelName) {
        var label = getLabel(labels[labelKey], labelName);
        switch (type) {
            case TOAST_INFO:
                toast.info(buildContent('information-circle', label));
                break;
            case TOAST_SUCCESS:
                toast.success(buildContent('checkmark-circle', label));
                break;
            case TOAST_FAILED:
                toast.error(buildContent('alert-circle', label));
                break;
            case TOAST_WARNING:
                toast.warn(buildContent('warning', label));
                break;
        }
    }; };
    var getLabels = function () {
        return labels;
    };
    var setLabels = function (labelsObject) {
        labels = labelsObject;
    };
    return {
        getLabels: getLabels,
        setLabels: setLabels,
        info: showToast(TOAST_INFO),
        success: showToast(TOAST_SUCCESS),
        failed: showToast(TOAST_FAILED),
        warning: showToast(TOAST_WARNING),
    };
};
var toastService$1 = toastService();

var defaultPositionOption = toast.POSITION.BOTTOM_CENTER;
var ToastContainer = function (_a) {
    var labels = _a.labels;
    useEffect(function () { return toastService$1.setLabels(labels); }, [labels]);
    return (createElement(ToastContainer$2, { autoClose: 6000, closeButton: createElement(Icon, { name: "close" }), position: defaultPositionOption, transition: Slide, newestOnTop: true }));
};
var ToastContainer$1 = memo(ToastContainer);

var getRest = function (props) {
    var className = props.className, index = props.index, number = props.number, label = props.label, status = props.status, hideLabel = props.hideLabel, onClick = props.onClick, disabled = props.disabled, rest = __rest(props, ["className", "index", "number", "label", "status", "hideLabel", "onClick", "disabled"]);
    return rest;
};
var Step = function (props) {
    var onClick = props.onClick, disabled = props.disabled, label = props.label, index = props.index, className = props.className, hideLabel = props.hideLabel, number = props.number, _a = props.status, status = _a === void 0 ? 'open' : _a;
    var onClickHandler = React__default.useCallback(function () {
        if (onClick && !disabled) {
            onClick(label, index);
        }
    }, [label, index, disabled, onClick]);
    // Only render this component as a button when there is a click handler
    if (!!onClick) {
        return (React__default.createElement("button", __assign({}, getRest(props), { className: classnames('step', "step--" + status, className), "aria-disabled": disabled, onClick: onClickHandler }),
            React__default.createElement(StepContent, { number: number, hideLabel: hideLabel, label: label, status: status })));
    }
    else {
        return (React__default.createElement("div", __assign({}, getRest(props), { className: classnames('step', "step--" + status, className), "aria-disabled": disabled, role: "group", tabIndex: 0 }),
            React__default.createElement(StepContent, { number: number, hideLabel: hideLabel, label: label, status: status })));
    }
};
var StepContent = function (_a) {
    var number = _a.number, hideLabel = _a.hideLabel, label = _a.label, status = _a.status;
    var getLabel = useIntl().getLabel;
    var accessibleStatusLabel = (status === 'active' && getLabel('common.active')) ||
        (status === 'skip' && getLabel('common.skipped'));
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("span", { className: "step__number" }, number),
        React__default.createElement(Icon, { className: "step__checkmark", name: "checkmark" }),
        React__default.createElement("span", { className: classnames('step__label', { 'step__label--hide-label': hideLabel }) }, label),
        accessibleStatusLabel && (React__default.createElement("span", { className: "step__visually-hidden" }, accessibleStatusLabel))));
};

var getStatus = function (active, index, skip) {
    if (active === index) {
        return 'active';
    }
    else if (skip) {
        return 'skip';
    }
    else if (active > index) {
        return 'done';
    }
    else {
        return 'open';
    }
};
var WizardProgress = function (_a) {
    var className = _a.className, steps = _a.steps, active = _a.active, _b = _a.withSeparators, withSeparators = _b === void 0 ? false : _b, labelStyle = _a.labelStyle, onClick = _a.onClick, skipSteps = _a.skipSteps, disableSteps = _a.disableSteps, rest = __rest(_a, ["className", "steps", "active", "withSeparators", "labelStyle", "onClick", "skipSteps", "disableSteps"]);
    return (React__default.createElement("div", __assign({}, rest, { className: classnames('wizard-progress', className, {
            'wizard-progress--with-inline-labels': labelStyle === 'inline',
            'wizard-progress--with-separators': withSeparators && labelStyle !== 'inline',
        }) }), steps.map(function (step, index) {
        var isSkip = skipSteps === null || skipSteps === void 0 ? void 0 : skipSteps.includes(index);
        var isDisabled = disableSteps === null || disableSteps === void 0 ? void 0 : disableSteps.includes(index);
        return (React__default.createElement(Step, { key: step, index: index, number: index + 1, label: step, className: classnames({
                'wizard-progress__step--with-spacing': !withSeparators && labelStyle === 'hidden',
            }), disabled: isSkip || isDisabled || false, hideLabel: labelStyle === 'hidden', status: getStatus(active, index, isSkip || false), onClick: onClick }));
    })));
};

var Breadcrumbs = function (_a) {
    var pages = _a.pages;
    if (!pages) {
        return null;
    }
    return (createElement("div", { className: "breadcrumbs" },
        pages.map(function (page, index) {
            return index + 1 < pages.length ? (createElement("div", { key: page.name, className: "breadcrumbs__link-wrapper" },
                createElement("a", { href: page.url, className: "breadcrumbs__link" }, page.name))) : (createElement("span", { key: page.name, className: "breadcrumbs__current-page-text" }, page.name));
        }),
        createElement(BreadcrumbList, { breadcrumbs: pages.slice(0, -1) })));
};

var InfinitePagination = function (_a) {
    var onClick = _a.onClick, buttonLabel = _a.buttonLabel, total = _a.total, loaded = _a.loaded, isLoading = _a.isLoading, labelKey = _a.labelKey, className = _a.className;
    var getFormattedLabel = useIntl().getFormattedLabel;
    var label = labelKey &&
        getFormattedLabel(labelKey, {
            labelData: {
                total: total,
                loaded: loaded > total ? total : loaded,
            },
        });
    return (createElement("div", { className: classnames('infinite-pagination', className) },
        createElement(ProgressBar, { value: loaded, max: total, className: "infinite-pagination__progress" }),
        label && createElement("div", { className: "infinite-pagination__label" }, label),
        loaded < total && (createElement(Button, { className: "infinite-pagination__button", "data-t": "pagination-load-more", caption: buttonLabel, onClick: onClick, variant: "outline", isLoading: isLoading }))));
};
var InfinitePagination$1 = memo(InfinitePagination);

// see https://polyfill.io/v3/url-builder/ for details
var FEATURES = [
    'default',
    'es2015',
    'es2016',
    'es2017',
    'es2018',
    'es5',
    'es6',
    'es7',
    'fetch',
    'IntersectionObserver',
    'smoothscroll',
];
var Polyfill = function (_a) {
    var _b = _a.features, features = _b === void 0 ? [] : _b;
    var filename = process.env.NODE_ENV === 'production' ? 'polyfill.min.js' : 'polyfill.js';
    var params = QueryString.stringify({
        rum: false,
        unknown: 'polyfill',
        flags: 'gated',
        features: uniq(__spread(FEATURES, features)).join(','),
    }, true);
    return (createElement(Fragment, null,
        createElement("link", { rel: "preconnect", href: "https://polyfill.io" }),
        createElement("script", { src: "https://polyfill.io/v3/" + filename + "?" + params })));
};
function uniq(arr) {
    return __spread(new Set(arr));
}

export { Accordion, AccordionItem, Alert, Backdrop, Breadcrumbs, Button, Card, Carousel, CartButton, CartCounter, CheckboxList, ContentTabs, Table as DataTable, DateTime, DiscountBar, Dropdown, ErrorBoundary, Expandable, EyeSideIndicator, FeatureGroup, Flyout, GoogleMaps, GoogleMapsContext, GoogleMapsProvider, IFrame, IconButton, IconLink, Image, InfinitePagination$1 as InfinitePagination, getLabel$1 as Labels, LazyImage, LineItem, LineItemAside, LineItemContent, LineItemDeleteButton, LineItemGlassesPrescription, LineItemMedia, LineItemSubtitle, LineItemTitle, Link, Link$1 as LinkTypes, List, Loader, LoaderScreen, LockBodyScroll, Logo, MarkerClusters, index as MediaQuery, Modal, NotificationBar, Olapic, OlapicContext, OlapicProvider, Pin, Polyfill, PreloadFonts, PrescriptionGlassesBundleChildItem, Price, PriceTag, ProgressBar, QuantitySelector, RadioButton, RadioButtonGroup, RangeSlider, RichTextArea, ScrollIntoView$1 as ScrollIntoView, ScrollUpButton, SelectionGroup, sharedProps as SharedProps, SimpleRangeSlider, SkeletonLoader, Sticky, StickyCallToAction, Summary, SummaryContainer, SummaryItem, SummaryLoader, SupportFooter, Tab, TabLink, Tabs, ToastContainer$1 as ToastContainer, Tooltip, index$1 as Util, WizardProgress, currencies, toastService$1 as toast, useGoogleMapsContext, useOlapicContext, withGoogleMaps };
//# sourceMappingURL=index.es.js.map
